(() => {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}


function $faa24f22a5163ec6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $faa24f22a5163ec6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $faa24f22a5163ec6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $faa24f22a5163ec6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $faa24f22a5163ec6$var$CREATED = 1;
var $faa24f22a5163ec6$var$MOUNTED = 2;
var $faa24f22a5163ec6$var$IDLE = 3;
var $faa24f22a5163ec6$var$MOVING = 4;
var $faa24f22a5163ec6$var$SCROLLING = 5;
var $faa24f22a5163ec6$var$DRAGGING = 6;
var $faa24f22a5163ec6$var$DESTROYED = 7;
var $faa24f22a5163ec6$var$STATES = {
    CREATED: $faa24f22a5163ec6$var$CREATED,
    MOUNTED: $faa24f22a5163ec6$var$MOUNTED,
    IDLE: $faa24f22a5163ec6$var$IDLE,
    MOVING: $faa24f22a5163ec6$var$MOVING,
    SCROLLING: $faa24f22a5163ec6$var$SCROLLING,
    DRAGGING: $faa24f22a5163ec6$var$DRAGGING,
    DESTROYED: $faa24f22a5163ec6$var$DESTROYED
};
function $faa24f22a5163ec6$var$empty(array) {
    array.length = 0;
}
function $faa24f22a5163ec6$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $faa24f22a5163ec6$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
}
var $faa24f22a5163ec6$var$nextTick = setTimeout;
var $faa24f22a5163ec6$var$noop = function noop() {};
function $faa24f22a5163ec6$var$raf(func) {
    return requestAnimationFrame(func);
}
function $faa24f22a5163ec6$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $faa24f22a5163ec6$var$isObject(subject) {
    return !$faa24f22a5163ec6$var$isNull(subject) && $faa24f22a5163ec6$var$typeOf("object", subject);
}
var $faa24f22a5163ec6$var$isArray = Array.isArray;
var $faa24f22a5163ec6$var$isFunction = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "function");
var $faa24f22a5163ec6$var$isString = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "string");
var $faa24f22a5163ec6$var$isUndefined = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "undefined");
function $faa24f22a5163ec6$var$isNull(subject) {
    return subject === null;
}
function $faa24f22a5163ec6$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $faa24f22a5163ec6$var$toArray(value) {
    return $faa24f22a5163ec6$var$isArray(value) ? value : [
        value
    ];
}
function $faa24f22a5163ec6$var$forEach(values, iteratee) {
    $faa24f22a5163ec6$var$toArray(values).forEach(iteratee);
}
function $faa24f22a5163ec6$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $faa24f22a5163ec6$var$push(array, items) {
    array.push.apply(array, $faa24f22a5163ec6$var$toArray(items));
    return array;
}
function $faa24f22a5163ec6$var$toggleClass(elm, classes, add) {
    if (elm) $faa24f22a5163ec6$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $faa24f22a5163ec6$var$addClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, $faa24f22a5163ec6$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $faa24f22a5163ec6$var$append(parent, children) {
    $faa24f22a5163ec6$var$forEach(children, parent.appendChild.bind(parent));
}
function $faa24f22a5163ec6$var$before(nodes, ref) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $faa24f22a5163ec6$var$matches(elm, selector) {
    return $faa24f22a5163ec6$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $faa24f22a5163ec6$var$children(parent, selector) {
    var children2 = parent ? $faa24f22a5163ec6$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $faa24f22a5163ec6$var$matches(child, selector);
    }) : children2;
}
function $faa24f22a5163ec6$var$child(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $faa24f22a5163ec6$var$ownKeys = Object.keys;
function $faa24f22a5163ec6$var$forOwn(object, iteratee, right) {
    if (object) (right ? $faa24f22a5163ec6$var$ownKeys(object).reverse() : $faa24f22a5163ec6$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $faa24f22a5163ec6$var$assign(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$merge(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            if ($faa24f22a5163ec6$var$isArray(value)) object[key] = value.slice();
            else if ($faa24f22a5163ec6$var$isObject(value)) object[key] = $faa24f22a5163ec6$var$merge({}, $faa24f22a5163ec6$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$omit(object, keys) {
    $faa24f22a5163ec6$var$forEach(keys || $faa24f22a5163ec6$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $faa24f22a5163ec6$var$removeAttribute(elms, attrs) {
    $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $faa24f22a5163ec6$var$setAttribute(elms, attrs, value) {
    if ($faa24f22a5163ec6$var$isObject(attrs)) $faa24f22a5163ec6$var$forOwn(attrs, function(value2, name) {
        $faa24f22a5163ec6$var$setAttribute(elms, name, value2);
    });
    else $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$isNull(value) || value === "" ? $faa24f22a5163ec6$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $faa24f22a5163ec6$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $faa24f22a5163ec6$var$isString(attrs) ? $faa24f22a5163ec6$var$addClass(elm, attrs) : $faa24f22a5163ec6$var$setAttribute(elm, attrs);
    parent && $faa24f22a5163ec6$var$append(parent, elm);
    return elm;
}
function $faa24f22a5163ec6$var$style(elm, prop, value) {
    if ($faa24f22a5163ec6$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$faa24f22a5163ec6$var$isNull(value)) elm.style[prop] = "" + value;
}
function $faa24f22a5163ec6$var$display(elm, display2) {
    $faa24f22a5163ec6$var$style(elm, "display", display2);
}
function $faa24f22a5163ec6$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $faa24f22a5163ec6$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $faa24f22a5163ec6$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $faa24f22a5163ec6$var$rect(target) {
    return target.getBoundingClientRect();
}
function $faa24f22a5163ec6$var$remove(nodes) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $faa24f22a5163ec6$var$parseHtml(html) {
    return $faa24f22a5163ec6$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $faa24f22a5163ec6$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $faa24f22a5163ec6$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $faa24f22a5163ec6$var$queryAll(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$slice(parent.querySelectorAll(selector)) : [];
}
function $faa24f22a5163ec6$var$removeClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, classes, false);
}
function $faa24f22a5163ec6$var$timeOf(e) {
    return e.timeStamp;
}
function $faa24f22a5163ec6$var$unit(value) {
    return $faa24f22a5163ec6$var$isString(value) ? value : value ? value + "px" : "";
}
var $faa24f22a5163ec6$var$PROJECT_CODE = "splide";
var $faa24f22a5163ec6$var$DATA_ATTRIBUTE = "data-" + $faa24f22a5163ec6$var$PROJECT_CODE;
function $faa24f22a5163ec6$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $faa24f22a5163ec6$var$PROJECT_CODE + "] " + (message || ""));
}
var $faa24f22a5163ec6$var$min = Math.min, $faa24f22a5163ec6$var$max = Math.max, $faa24f22a5163ec6$var$floor = Math.floor, $faa24f22a5163ec6$var$ceil = Math.ceil, $faa24f22a5163ec6$var$abs = Math.abs;
function $faa24f22a5163ec6$var$approximatelyEqual(x, y, epsilon) {
    return $faa24f22a5163ec6$var$abs(x - y) < epsilon;
}
function $faa24f22a5163ec6$var$between(number, x, y, exclusive) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $faa24f22a5163ec6$var$clamp(number, x, y) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$max(minimum, number), maximum);
}
function $faa24f22a5163ec6$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $faa24f22a5163ec6$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $faa24f22a5163ec6$var$format(string, replacements) {
    $faa24f22a5163ec6$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $faa24f22a5163ec6$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $faa24f22a5163ec6$var$ids = {};
function $faa24f22a5163ec6$var$uniqueId(prefix) {
    return "" + prefix + $faa24f22a5163ec6$var$pad($faa24f22a5163ec6$var$ids[prefix] = ($faa24f22a5163ec6$var$ids[prefix] || 0) + 1);
}
function $faa24f22a5163ec6$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $faa24f22a5163ec6$var$forEach(targets, function(target) {
            target && $faa24f22a5163ec6$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $faa24f22a5163ec6$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$export$d300dc1a2634364b = "mounted";
var $faa24f22a5163ec6$export$d8dac49b4532735a = "ready";
var $faa24f22a5163ec6$export$2aa493d7c3275167 = "move";
var $faa24f22a5163ec6$export$fe5802204b967f0d = "moved";
var $faa24f22a5163ec6$export$5adb665701eda1ce = "click";
var $faa24f22a5163ec6$export$92e3eae133acac4c = "active";
var $faa24f22a5163ec6$export$6bcbb81035c12cea = "inactive";
var $faa24f22a5163ec6$export$6a5b3445e4066a53 = "visible";
var $faa24f22a5163ec6$export$8c5c7a21d54563e9 = "hidden";
var $faa24f22a5163ec6$export$7f4701ac5e05e39f = "refresh";
var $faa24f22a5163ec6$export$db40ab7c0855fa5c = "updated";
var $faa24f22a5163ec6$export$7e019dae5103a285 = "resize";
var $faa24f22a5163ec6$export$d637eba1e9e28482 = "resized";
var $faa24f22a5163ec6$export$e84bf5065c9087ac = "drag";
var $faa24f22a5163ec6$export$8e9f636d2c722196 = "dragging";
var $faa24f22a5163ec6$export$90ea576bd3fdeb60 = "dragged";
var $faa24f22a5163ec6$export$49801896908b5e33 = "scroll";
var $faa24f22a5163ec6$export$ff8164bff3202b9 = "scrolled";
var $faa24f22a5163ec6$export$6cbac5b662a31e1b = "overflow";
var $faa24f22a5163ec6$export$88c4cf7419e470cd = "destroy";
var $faa24f22a5163ec6$export$8647f6b043e04e9d = "arrows:mounted";
var $faa24f22a5163ec6$export$d467f9343b961f75 = "arrows:updated";
var $faa24f22a5163ec6$export$bf89a4e4349c9778 = "pagination:mounted";
var $faa24f22a5163ec6$export$eb2019082ed6de0b = "pagination:updated";
var $faa24f22a5163ec6$export$84015c33508f94ec = "navigation:mounted";
var $faa24f22a5163ec6$export$23663268a31b79e2 = "autoplay:play";
var $faa24f22a5163ec6$export$185723258309b608 = "autoplay:playing";
var $faa24f22a5163ec6$export$16a1e4f3d0368265 = "autoplay:pause";
var $faa24f22a5163ec6$export$9f64346e17f0ec8e = "lazyload:loaded";
var $faa24f22a5163ec6$export$6d5af59619d10e6a = "sk";
var $faa24f22a5163ec6$export$f0af896383d5adff = "sh";
var $faa24f22a5163ec6$export$28dea85f216954dc = "ei";
function $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $faa24f22a5163ec6$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $faa24f22a5163ec6$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $faa24f22a5163ec6$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($faa24f22a5163ec6$export$88c4cf7419e470cd, binder.destroy);
    return $faa24f22a5163ec6$var$assign(binder, {
        bus: bus,
        on: on,
        off: $faa24f22a5163ec6$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $faa24f22a5163ec6$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $faa24f22a5163ec6$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $faa24f22a5163ec6$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $faa24f22a5163ec6$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $faa24f22a5163ec6$export$efff0f5979573c99(func, duration) {
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $faa24f22a5163ec6$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $faa24f22a5163ec6$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($faa24f22a5163ec6$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $faa24f22a5163ec6$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $faa24f22a5163ec6$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $faa24f22a5163ec6$var$merge(options, reducedMotion) : $faa24f22a5163ec6$var$omit(options, $faa24f22a5163ec6$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $faa24f22a5163ec6$var$merge(options, opts);
        base && $faa24f22a5163ec6$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($faa24f22a5163ec6$var$CREATED)) Splide2.emit($faa24f22a5163ec6$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $faa24f22a5163ec6$var$ARROW = "Arrow";
var $faa24f22a5163ec6$var$ARROW_LEFT = $faa24f22a5163ec6$var$ARROW + "Left";
var $faa24f22a5163ec6$var$ARROW_RIGHT = $faa24f22a5163ec6$var$ARROW + "Right";
var $faa24f22a5163ec6$var$ARROW_UP = $faa24f22a5163ec6$var$ARROW + "Up";
var $faa24f22a5163ec6$var$ARROW_DOWN = $faa24f22a5163ec6$var$ARROW + "Down";
var $faa24f22a5163ec6$export$373e92e0788ff06e = "ltr";
var $faa24f22a5163ec6$export$850f7749a2909601 = "rtl";
var $faa24f22a5163ec6$export$97170d9824b89709 = "ttb";
var $faa24f22a5163ec6$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $faa24f22a5163ec6$var$ARROW_UP,
        $faa24f22a5163ec6$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $faa24f22a5163ec6$var$ARROW_DOWN,
        $faa24f22a5163ec6$var$ARROW_LEFT
    ]
};
function $faa24f22a5163ec6$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $faa24f22a5163ec6$export$850f7749a2909601 && !axisOnly ? 1 : direction === $faa24f22a5163ec6$export$97170d9824b89709 ? 0 : -1;
        return $faa24f22a5163ec6$var$ORIENTATION_MAP[prop] && $faa24f22a5163ec6$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $faa24f22a5163ec6$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $faa24f22a5163ec6$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $faa24f22a5163ec6$var$ROLE = "role";
var $faa24f22a5163ec6$var$TAB_INDEX = "tabindex";
var $faa24f22a5163ec6$var$DISABLED = "disabled";
var $faa24f22a5163ec6$var$ARIA_PREFIX = "aria-";
var $faa24f22a5163ec6$var$ARIA_CONTROLS = $faa24f22a5163ec6$var$ARIA_PREFIX + "controls";
var $faa24f22a5163ec6$var$ARIA_CURRENT = $faa24f22a5163ec6$var$ARIA_PREFIX + "current";
var $faa24f22a5163ec6$var$ARIA_SELECTED = $faa24f22a5163ec6$var$ARIA_PREFIX + "selected";
var $faa24f22a5163ec6$var$ARIA_LABEL = $faa24f22a5163ec6$var$ARIA_PREFIX + "label";
var $faa24f22a5163ec6$var$ARIA_LABELLEDBY = $faa24f22a5163ec6$var$ARIA_PREFIX + "labelledby";
var $faa24f22a5163ec6$var$ARIA_HIDDEN = $faa24f22a5163ec6$var$ARIA_PREFIX + "hidden";
var $faa24f22a5163ec6$var$ARIA_ORIENTATION = $faa24f22a5163ec6$var$ARIA_PREFIX + "orientation";
var $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION = $faa24f22a5163ec6$var$ARIA_PREFIX + "roledescription";
var $faa24f22a5163ec6$var$ARIA_LIVE = $faa24f22a5163ec6$var$ARIA_PREFIX + "live";
var $faa24f22a5163ec6$var$ARIA_BUSY = $faa24f22a5163ec6$var$ARIA_PREFIX + "busy";
var $faa24f22a5163ec6$var$ARIA_ATOMIC = $faa24f22a5163ec6$var$ARIA_PREFIX + "atomic";
var $faa24f22a5163ec6$var$ALL_ATTRIBUTES = [
    $faa24f22a5163ec6$var$ROLE,
    $faa24f22a5163ec6$var$TAB_INDEX,
    $faa24f22a5163ec6$var$DISABLED,
    $faa24f22a5163ec6$var$ARIA_CONTROLS,
    $faa24f22a5163ec6$var$ARIA_CURRENT,
    $faa24f22a5163ec6$var$ARIA_LABEL,
    $faa24f22a5163ec6$var$ARIA_LABELLEDBY,
    $faa24f22a5163ec6$var$ARIA_HIDDEN,
    $faa24f22a5163ec6$var$ARIA_ORIENTATION,
    $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
];
var $faa24f22a5163ec6$var$CLASS_PREFIX = $faa24f22a5163ec6$var$PROJECT_CODE + "__";
var $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX = "is-";
var $faa24f22a5163ec6$export$93b21159ad85c843 = $faa24f22a5163ec6$var$PROJECT_CODE;
var $faa24f22a5163ec6$export$7738b09ac0a98952 = $faa24f22a5163ec6$var$CLASS_PREFIX + "track";
var $faa24f22a5163ec6$export$19cc2a5451235cae = $faa24f22a5163ec6$var$CLASS_PREFIX + "list";
var $faa24f22a5163ec6$export$8d922915837a38d3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "slide";
var $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 = $faa24f22a5163ec6$export$8d922915837a38d3 + "--clone";
var $faa24f22a5163ec6$export$e9ba7e444ba60a12 = $faa24f22a5163ec6$export$8d922915837a38d3 + "__container";
var $faa24f22a5163ec6$export$a26cbd955fecf11e = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrows";
var $faa24f22a5163ec6$export$516e7d18e13a2dca = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrow";
var $faa24f22a5163ec6$export$58ea3db24c33b76 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--prev";
var $faa24f22a5163ec6$export$4885afd7098a65c2 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--next";
var $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "pagination";
var $faa24f22a5163ec6$export$52f2cca6a5eee805 = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "__page";
var $faa24f22a5163ec6$export$4c82dc32b1c4ace5 = $faa24f22a5163ec6$var$CLASS_PREFIX + "progress";
var $faa24f22a5163ec6$export$2c9b091c749f4409 = $faa24f22a5163ec6$export$4c82dc32b1c4ace5 + "__bar";
var $faa24f22a5163ec6$export$a29701deef84b825 = $faa24f22a5163ec6$var$CLASS_PREFIX + "toggle";
var $faa24f22a5163ec6$export$d9d247d51b430dbb = $faa24f22a5163ec6$export$a29701deef84b825 + "__play";
var $faa24f22a5163ec6$export$3529f201a419925b = $faa24f22a5163ec6$export$a29701deef84b825 + "__pause";
var $faa24f22a5163ec6$export$3e5381ee3fab8374 = $faa24f22a5163ec6$var$CLASS_PREFIX + "spinner";
var $faa24f22a5163ec6$export$bb78d7c200da8960 = $faa24f22a5163ec6$var$CLASS_PREFIX + "sr";
var $faa24f22a5163ec6$export$7761661e2d5b9388 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "initialized";
var $faa24f22a5163ec6$export$72d36ecf3758cb4b = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "active";
var $faa24f22a5163ec6$export$e423ac4972f5e196 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "prev";
var $faa24f22a5163ec6$export$457a2d20827a2779 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "next";
var $faa24f22a5163ec6$export$53ca4621bbab9a = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "visible";
var $faa24f22a5163ec6$export$d22ec4ccb7996ba2 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "loading";
var $faa24f22a5163ec6$export$b6f202a162a09100 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "focus-in";
var $faa24f22a5163ec6$export$cd908cd1dd625e29 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "overflow";
var $faa24f22a5163ec6$export$49f9eaea10ebf193 = [
    $faa24f22a5163ec6$export$72d36ecf3758cb4b,
    $faa24f22a5163ec6$export$53ca4621bbab9a,
    $faa24f22a5163ec6$export$e423ac4972f5e196,
    $faa24f22a5163ec6$export$457a2d20827a2779,
    $faa24f22a5163ec6$export$d22ec4ccb7996ba2,
    $faa24f22a5163ec6$export$b6f202a162a09100,
    $faa24f22a5163ec6$export$cd908cd1dd625e29
];
var $faa24f22a5163ec6$export$ba41d43e4a419565 = {
    slide: $faa24f22a5163ec6$export$8d922915837a38d3,
    clone: $faa24f22a5163ec6$export$2c1ba4a4f1aa4947,
    arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
    arrow: $faa24f22a5163ec6$export$516e7d18e13a2dca,
    prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
    next: $faa24f22a5163ec6$export$4885afd7098a65c2,
    pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
    page: $faa24f22a5163ec6$export$52f2cca6a5eee805,
    spinner: $faa24f22a5163ec6$export$3e5381ee3fab8374
};
function $faa24f22a5163ec6$var$closest(from, selector) {
    if ($faa24f22a5163ec6$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($faa24f22a5163ec6$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $faa24f22a5163ec6$var$FRICTION = 5;
var $faa24f22a5163ec6$var$LOG_INTERVAL = 200;
var $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $faa24f22a5163ec6$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $faa24f22a5163ec6$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, setup);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, update);
        bind(document, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $faa24f22a5163ec6$var$ALL_ATTRIBUTES.concat("style");
        $faa24f22a5163ec6$var$empty(slides);
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        $faa24f22a5163ec6$var$removeAttribute([
            track,
            list
        ], attrs);
        $faa24f22a5163ec6$var$removeAttribute(root, completely ? attrs : [
            "style",
            $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        rootClasses = getClasses($faa24f22a5163ec6$export$93b21159ad85c843);
        trackClasses = getClasses($faa24f22a5163ec6$export$7738b09ac0a98952);
        $faa24f22a5163ec6$var$addClass(root, rootClasses);
        $faa24f22a5163ec6$var$addClass(track, trackClasses);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL, options.label);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $faa24f22a5163ec6$export$7738b09ac0a98952);
        list = $faa24f22a5163ec6$var$child(track, "." + $faa24f22a5163ec6$export$19cc2a5451235cae);
        $faa24f22a5163ec6$var$assert(track && list, "A track/list element is missing.");
        $faa24f22a5163ec6$var$push(slides, $faa24f22a5163ec6$var$children(list, "." + $faa24f22a5163ec6$export$8d922915837a38d3 + ":not(." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 + ")"));
        $faa24f22a5163ec6$var$forOwn({
            arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
            pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
            prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
            next: $faa24f22a5163ec6$export$4885afd7098a65c2,
            bar: $faa24f22a5163ec6$export$2c9b091c749f4409,
            toggle: $faa24f22a5163ec6$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $faa24f22a5163ec6$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $faa24f22a5163ec6$var$uniqueId($faa24f22a5163ec6$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ROLE) && root.tagName !== "SECTION" && role) $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ROLE, role);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $faa24f22a5163ec6$var$query(root, selector);
        return elm && $faa24f22a5163ec6$var$closest(elm, "." + $faa24f22a5163ec6$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $faa24f22a5163ec6$export$93b21159ad85c843 && $faa24f22a5163ec6$export$72d36ecf3758cb4b
        ];
    }
    return $faa24f22a5163ec6$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $faa24f22a5163ec6$export$e5a58a5ee5b54c22 = "slide";
var $faa24f22a5163ec6$export$f42383286ed1223d = "loop";
var $faa24f22a5163ec6$export$742b62a5690c060 = "fade";
function $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $faa24f22a5163ec6$var$getAttribute(slide, "style");
    var label = $faa24f22a5163ec6$var$getAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $faa24f22a5163ec6$var$child(slide, "." + $faa24f22a5163ec6$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $faa24f22a5163ec6$var$pad(index + 1);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, pagination ? "tabpanel" : "group");
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || $faa24f22a5163ec6$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$6d5af59619d10e6a, self));
        on([
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$f0af896383d5adff,
            $faa24f22a5163ec6$export$ff8164bff3202b9
        ], update);
        on($faa24f22a5163ec6$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(slide, $faa24f22a5163ec6$export$49f9eaea10ebf193);
        $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
        $faa24f22a5163ec6$var$setAttribute(slide, "style", styles);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$e423ac4972f5e196, index === curr - 1);
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b, active);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $faa24f22a5163ec6$export$92e3eae133acac4c : $faa24f22a5163ec6$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ])) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_HIDDEN, hidden || "");
        $faa24f22a5163ec6$var$setAttribute($faa24f22a5163ec6$var$queryAll(slide, options.focusableNodes || ""), $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a, visible);
            emit(visible ? $faa24f22a5163ec6$export$6a5b3445e4066a53 : $faa24f22a5163ec6$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $faa24f22a5163ec6$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $faa24f22a5163ec6$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) return isActive();
        var trackRect = $faa24f22a5163ec6$var$rect(Components.Elements.track);
        var slideRect = $faa24f22a5163ec6$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $faa24f22a5163ec6$var$floor(trackRect[left]) <= $faa24f22a5163ec6$var$ceil(slideRect[left]) && $faa24f22a5163ec6$var$floor(slideRect[right]) <= $faa24f22a5163ec6$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $faa24f22a5163ec6$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d))) diff = $faa24f22a5163ec6$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $faa24f22a5163ec6$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $faa24f22a5163ec6$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $faa24f22a5163ec6$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $faa24f22a5163ec6$var$forEach(items, function(slide) {
            if ($faa24f22a5163ec6$var$isString(slide)) slide = $faa24f22a5163ec6$var$parseHtml(slide);
            if ($faa24f22a5163ec6$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $faa24f22a5163ec6$var$before(slide, ref) : $faa24f22a5163ec6$var$append(list, slide);
                $faa24f22a5163ec6$var$addClass(slide, options.classes.slide);
                observeImages(slide, $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285));
            }
        });
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $faa24f22a5163ec6$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($faa24f22a5163ec6$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $faa24f22a5163ec6$var$isString(matcher) ? $faa24f22a5163ec6$var$matches(Slide2.slide, matcher) : $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $faa24f22a5163ec6$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $faa24f22a5163ec6$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $faa24f22a5163ec6$export$efff0f5979573c99($faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285)));
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
        on($faa24f22a5163ec6$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
        $faa24f22a5163ec6$var$style(root, "maxWidth", $faa24f22a5163ec6$var$unit(options.width));
        $faa24f22a5163ec6$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $faa24f22a5163ec6$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $faa24f22a5163ec6$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $faa24f22a5163ec6$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($faa24f22a5163ec6$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$cd908cd1dd625e29, overflow);
                emit($faa24f22a5163ec6$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $faa24f22a5163ec6$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $faa24f22a5163ec6$var$unit(options.height || $faa24f22a5163ec6$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $faa24f22a5163ec6$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("right")];
            var left = $faa24f22a5163ec6$var$rect(list)[resolve("left")];
            return $faa24f22a5163ec6$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($faa24f22a5163ec6$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($faa24f22a5163ec6$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($faa24f22a5163ec6$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $faa24f22a5163ec6$var$MULTIPLIER = 2;
function $faa24f22a5163ec6$var$Clones(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, remount);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $faa24f22a5163ec6$var$remove(clones);
        $faa24f22a5163ec6$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
            $faa24f22a5163ec6$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $faa24f22a5163ec6$var$before(clone, slides[0].slide) : $faa24f22a5163ec6$var$append(Elements.list, clone);
                $faa24f22a5163ec6$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $faa24f22a5163ec6$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $faa24f22a5163ec6$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) clones2 = 0;
        else if ($faa24f22a5163ec6$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $faa24f22a5163ec6$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $faa24f22a5163ec6$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$d637eba1e9e28482,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($faa24f22a5163ec6$var$MOVING);
        emit($faa24f22a5163ec6$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $faa24f22a5163ec6$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($faa24f22a5163ec6$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $faa24f22a5163ec6$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $faa24f22a5163ec6$var$rect(list)[left] - $faa24f22a5163ec6$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22)) position = $faa24f22a5163ec6$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $faa24f22a5163ec6$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $faa24f22a5163ec6$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $faa24f22a5163ec6$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d);
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var getNext = $faa24f22a5163ec6$var$apply(getAdjacent, false);
    var getPrev = $faa24f22a5163ec6$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], init);
        on($faa24f22a5163ec6$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $faa24f22a5163ec6$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($faa24f22a5163ec6$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $faa24f22a5163ec6$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($faa24f22a5163ec6$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $faa24f22a5163ec6$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$faa24f22a5163ec6$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($faa24f22a5163ec6$var$between(0, dest, from, true) || $faa24f22a5163ec6$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $faa24f22a5163ec6$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $faa24f22a5163ec6$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $faa24f22a5163ec6$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $faa24f22a5163ec6$var$min(index, endIndex) : $faa24f22a5163ec6$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $faa24f22a5163ec6$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$faa24f22a5163ec6$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $faa24f22a5163ec6$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $faa24f22a5163ec6$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $faa24f22a5163ec6$var$SIZE = 40;
function $faa24f22a5163ec6$var$Arrows(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $faa24f22a5163ec6$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $faa24f22a5163ec6$var$display(wrapper, enabled ? "" : "none");
            $faa24f22a5163ec6$var$addClass(wrapper, wrapperClasses = $faa24f22a5163ec6$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $faa24f22a5163ec6$var$setAttribute([
                    prev,
                    next
                ], $faa24f22a5163ec6$var$ARIA_CONTROLS, track.id);
                emit($faa24f22a5163ec6$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $faa24f22a5163ec6$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $faa24f22a5163ec6$var$removeAttribute([
            prev,
            next
        ], $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$ff8164bff3202b9,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], update);
        bind(next, "click", $faa24f22a5163ec6$var$apply(go, ">"));
        bind(prev, "click", $faa24f22a5163ec6$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $faa24f22a5163ec6$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $faa24f22a5163ec6$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $faa24f22a5163ec6$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $faa24f22a5163ec6$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + '" width="' + $faa24f22a5163ec6$var$SIZE + '" height="' + $faa24f22a5163ec6$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $faa24f22a5163ec6$var$PATH) + '" />';
        return $faa24f22a5163ec6$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $faa24f22a5163ec6$var$setAttribute(prev, $faa24f22a5163ec6$var$ARIA_LABEL, prevLabel);
            $faa24f22a5163ec6$var$setAttribute(next, $faa24f22a5163ec6$var$ARIA_LABEL, nextLabel);
            emit($faa24f22a5163ec6$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-interval";
function $faa24f22a5163ec6$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $faa24f22a5163ec6$export$2aa493d7c3275167,
            $faa24f22a5163ec6$export$49801896908b5e33,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($faa24f22a5163ec6$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($faa24f22a5163ec6$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $faa24f22a5163ec6$var$toggleClass(toggle, $faa24f22a5163ec6$export$72d36ecf3758cb4b, !stopped);
            $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $faa24f22a5163ec6$var$style(bar, "width", rate * 100 + "%");
        emit($faa24f22a5163ec6$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$faa24f22a5163ec6$var$getAttribute(Slide.slide, $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($faa24f22a5163ec6$export$9f64346e17f0ec8e, $faa24f22a5163ec6$var$apply(toggle, true));
            on([
                $faa24f22a5163ec6$export$d300dc1a2634364b,
                $faa24f22a5163ec6$export$db40ab7c0855fa5c,
                $faa24f22a5163ec6$export$7f4701ac5e05e39f
            ], $faa24f22a5163ec6$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $faa24f22a5163ec6$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $faa24f22a5163ec6$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply(cover, false)
    };
}
var $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD = 10;
var $faa24f22a5163ec6$var$BOUNCE_DURATION = 600;
var $faa24f22a5163ec6$var$FRICTION_FACTOR = 0.6;
var $faa24f22a5163ec6$var$BASE_VELOCITY = 1.5;
var $faa24f22a5163ec6$var$MIN_DURATION = 800;
function $faa24f22a5163ec6$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($faa24f22a5163ec6$export$2aa493d7c3275167, clear);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $faa24f22a5163ec6$var$sign(destination) * size * $faa24f22a5163ec6$var$floor($faa24f22a5163ec6$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $faa24f22a5163ec6$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $faa24f22a5163ec6$var$max($faa24f22a5163ec6$var$abs(destination - from) / $faa24f22a5163ec6$var$BASE_VELOCITY, $faa24f22a5163ec6$var$MIN_DURATION);
        callback = onScrolled;
        interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration, onEnd, $faa24f22a5163ec6$var$apply(update, from, destination, noConstrain), 1);
        set($faa24f22a5163ec6$var$SCROLLING);
        emit($faa24f22a5163ec6$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($faa24f22a5163ec6$var$IDLE);
        callback && callback();
        emit($faa24f22a5163ec6$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $faa24f22a5163ec6$var$FRICTION_FACTOR;
            if ($faa24f22a5163ec6$var$abs(diff) < $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $faa24f22a5163ec6$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $faa24f22a5163ec6$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS, onPointerDown, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $faa24f22a5163ec6$var$prevent);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $faa24f22a5163ec6$var$MOVING,
                        $faa24f22a5163ec6$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $faa24f22a5163ec6$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$DRAGGING);
            emit($faa24f22a5163ec6$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $faa24f22a5163ec6$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($faa24f22a5163ec6$export$8e9f636d2c722196);
                $faa24f22a5163ec6$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $faa24f22a5163ec6$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $faa24f22a5163ec6$var$prevent(e);
        }
        unbind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $faa24f22a5163ec6$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) Controller.go(orient($faa24f22a5163ec6$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $faa24f22a5163ec6$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > $faa24f22a5163ec6$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $faa24f22a5163ec6$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $faa24f22a5163ec6$var$sign(velocity) * $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $faa24f22a5163ec6$var$timeOf(e) - $faa24f22a5163ec6$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) ? $faa24f22a5163ec6$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$faa24f22a5163ec6$var$matches(target2, "." + $faa24f22a5163ec6$export$52f2cca6a5eee805 + ", ." + $faa24f22a5163ec6$export$516e7d18e13a2dca) && (!noDrag || !$faa24f22a5163ec6$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $faa24f22a5163ec6$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $faa24f22a5163ec6$var$ARROW_RIGHT,
    Left: $faa24f22a5163ec6$var$ARROW_LEFT,
    Up: $faa24f22a5163ec6$var$ARROW_UP,
    Down: $faa24f22a5163ec6$var$ARROW_DOWN
};
function $faa24f22a5163ec6$var$normalizeKey(key) {
    key = $faa24f22a5163ec6$var$isString(key) ? key : key.key;
    return $faa24f22a5163ec6$var$NORMALIZATION_MAP[key] || key;
}
var $faa24f22a5163ec6$var$KEYBOARD_EVENT = "keydown";
function $faa24f22a5163ec6$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, destroy);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, init);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $faa24f22a5163ec6$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $faa24f22a5163ec6$var$normalizeKey(e);
            if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-lazy";
var $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $faa24f22a5163ec6$var$IMAGE_SELECTOR = "[" + $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "], [" + $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE + "]";
function $faa24f22a5163ec6$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $faa24f22a5163ec6$export$fe5802204b967f0d,
        $faa24f22a5163ec6$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $faa24f22a5163ec6$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $faa24f22a5163ec6$var$queryAll(Slide.slide, $faa24f22a5163ec6$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
                var srcset = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $faa24f22a5163ec6$var$child(parent, "." + className) || $faa24f22a5163ec6$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $faa24f22a5163ec6$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $faa24f22a5163ec6$var$addClass(data[1].slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        bind(img, "load error", $faa24f22a5163ec6$var$apply(onLoad, data));
        $faa24f22a5163ec6$var$setAttribute(img, "src", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$setAttribute(img, "srcset", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $faa24f22a5163ec6$var$removeClass(Slide.slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $faa24f22a5163ec6$var$remove(data[2]);
            $faa24f22a5163ec6$var$display(img, "");
            emit($faa24f22a5163ec6$export$9f64346e17f0ec8e, img, Slide);
            emit($faa24f22a5163ec6$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$empty, entries),
        check: check
    };
}
function $faa24f22a5163ec6$var$Pagination(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $faa24f22a5163ec6$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $faa24f22a5163ec6$export$2aa493d7c3275167,
                $faa24f22a5163ec6$export$49801896908b5e33,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($faa24f22a5163ec6$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $faa24f22a5163ec6$var$remove(placeholder ? $faa24f22a5163ec6$var$slice(list.children) : list);
            $faa24f22a5163ec6$var$removeClass(list, paginationClasses);
            $faa24f22a5163ec6$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $faa24f22a5163ec6$var$ceil(length / perPage);
        list = placeholder || $faa24f22a5163ec6$var$create("ul", classes.pagination, Elements.track.parentElement);
        $faa24f22a5163ec6$var$addClass(list, paginationClasses = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "tablist");
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_LABEL, i18n.select);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, getDirection() === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $faa24f22a5163ec6$var$create("li", null, list);
            var button = $faa24f22a5163ec6$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $faa24f22a5163ec6$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $faa24f22a5163ec6$var$apply(onKeydown, i));
            $faa24f22a5163ec6$var$setAttribute(li, $faa24f22a5163ec6$var$ROLE, "presentation");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ROLE, "tab");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls.join(" "));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(text, i + 1));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $faa24f22a5163ec6$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $faa24f22a5163ec6$var$focus(item.button);
            go(">" + nextPage);
            $faa24f22a5163ec6$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $faa24f22a5163ec6$var$removeClass(button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$removeAttribute(button, $faa24f22a5163ec6$var$ARIA_SELECTED);
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $faa24f22a5163ec6$var$addClass(_button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$ARIA_SELECTED, true);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$TAB_INDEX, "");
        }
        emit($faa24f22a5163ec6$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $faa24f22a5163ec6$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $faa24f22a5163ec6$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $faa24f22a5163ec6$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(splide);
        event.on($faa24f22a5163ec6$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($faa24f22a5163ec6$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($faa24f22a5163ec6$export$5adb665701eda1ce, onClick);
        on($faa24f22a5163ec6$export$6d5af59619d10e6a, onKeydown);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($faa24f22a5163ec6$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $faa24f22a5163ec6$var$setAttribute(Components2.Elements.list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, options.direction === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$TRIGGER_KEYS, $faa24f22a5163ec6$var$normalizeKey(e))) {
            onClick(Slide);
            $faa24f22a5163ec6$var$prevent(e);
        }
    }
    return {
        setup: $faa24f22a5163ec6$var$apply(Components2.Media.set, {
            slideFocus: $faa24f22a5163ec6$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $faa24f22a5163ec6$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $faa24f22a5163ec6$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($faa24f22a5163ec6$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $faa24f22a5163ec6$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($faa24f22a5163ec6$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $faa24f22a5163ec6$var$SR_REMOVAL_DELAY = 90;
function $faa24f22a5163ec6$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $faa24f22a5163ec6$var$create("span", $faa24f22a5163ec6$export$bb78d7c200da8960);
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0($faa24f22a5163ec6$var$SR_REMOVAL_DELAY, $faa24f22a5163ec6$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($faa24f22a5163ec6$export$23663268a31b79e2, $faa24f22a5163ec6$var$apply(disable, true));
            on($faa24f22a5163ec6$export$16a1e4f3d0368265, $faa24f22a5163ec6$var$apply(disable, false));
            on([
                $faa24f22a5163ec6$export$fe5802204b967f0d,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], $faa24f22a5163ec6$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_BUSY, active);
        if (active) {
            $faa24f22a5163ec6$var$append(track, sr);
            interval.start();
        } else {
            $faa24f22a5163ec6$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $faa24f22a5163ec6$var$removeAttribute(track, [
            $faa24f22a5163ec6$var$ARIA_LIVE,
            $faa24f22a5163ec6$var$ARIA_ATOMIC,
            $faa24f22a5163ec6$var$ARIA_BUSY
        ]);
        $faa24f22a5163ec6$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $faa24f22a5163ec6$var$Media,
    Direction: $faa24f22a5163ec6$var$Direction,
    Elements: $faa24f22a5163ec6$var$Elements,
    Slides: $faa24f22a5163ec6$var$Slides,
    Layout: $faa24f22a5163ec6$var$Layout,
    Clones: $faa24f22a5163ec6$var$Clones,
    Move: $faa24f22a5163ec6$var$Move,
    Controller: $faa24f22a5163ec6$var$Controller,
    Arrows: $faa24f22a5163ec6$var$Arrows,
    Autoplay: $faa24f22a5163ec6$var$Autoplay,
    Cover: $faa24f22a5163ec6$var$Cover,
    Scroll: $faa24f22a5163ec6$var$Scroll,
    Drag: $faa24f22a5163ec6$var$Drag,
    Keyboard: $faa24f22a5163ec6$var$Keyboard,
    LazyLoad: $faa24f22a5163ec6$var$LazyLoad,
    Pagination: $faa24f22a5163ec6$var$Pagination,
    Sync: $faa24f22a5163ec6$var$Sync,
    Wheel: $faa24f22a5163ec6$var$Wheel,
    Live: $faa24f22a5163ec6$var$Live
});
var $faa24f22a5163ec6$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $faa24f22a5163ec6$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $faa24f22a5163ec6$export$ba41d43e4a419565,
    i18n: $faa24f22a5163ec6$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $faa24f22a5163ec6$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $faa24f22a5163ec6$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $faa24f22a5163ec6$var$noop
    };
}
function $faa24f22a5163ec6$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$style, list, "transition");
    var endCallback;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($faa24f22a5163ec6$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $faa24f22a5163ec6$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $faa24f22a5163ec6$export$7254cc27399e90bd($faa24f22a5163ec6$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $faa24f22a5163ec6$var$isString(target) ? $faa24f22a5163ec6$var$query(document, target) : target;
        $faa24f22a5163ec6$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $faa24f22a5163ec6$var$merge({
            label: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL) || "",
            labelledby: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY) || ""
        }, $faa24f22a5163ec6$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $faa24f22a5163ec6$var$merge(options, JSON.parse($faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $faa24f22a5163ec6$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($faa24f22a5163ec6$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $faa24f22a5163ec6$var$assert(state.is([
            $faa24f22a5163ec6$var$CREATED,
            $faa24f22a5163ec6$var$DESTROYED
        ]), "Already mounted!");
        state.set($faa24f22a5163ec6$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($faa24f22a5163ec6$export$742b62a5690c060) ? $faa24f22a5163ec6$var$Fade : $faa24f22a5163ec6$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $faa24f22a5163ec6$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $faa24f22a5163ec6$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($faa24f22a5163ec6$export$d300dc1a2634364b);
        $faa24f22a5163ec6$var$addClass(this.root, $faa24f22a5163ec6$export$7761661e2d5b9388);
        state.set($faa24f22a5163ec6$var$IDLE);
        this.emit($faa24f22a5163ec6$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($faa24f22a5163ec6$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($faa24f22a5163ec6$var$CREATED)) $faa24f22a5163ec6$export$f188226459c8a3ff(this).on($faa24f22a5163ec6$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $faa24f22a5163ec6$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($faa24f22a5163ec6$export$88c4cf7419e470cd);
            event.destroy();
            completely && $faa24f22a5163ec6$var$empty(this.splides);
            state.set($faa24f22a5163ec6$var$DESTROYED);
        }
        return this;
    };
    $faa24f22a5163ec6$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $faa24f22a5163ec6$export$24494c7438c070bf = $faa24f22a5163ec6$var$_Splide;
$faa24f22a5163ec6$export$24494c7438c070bf.defaults = {};
$faa24f22a5163ec6$export$24494c7438c070bf.STATES = $faa24f22a5163ec6$var$STATES;
var $faa24f22a5163ec6$var$CLASS_RENDERED = "is-rendered";
var $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $faa24f22a5163ec6$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $faa24f22a5163ec6$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $faa24f22a5163ec6$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $faa24f22a5163ec6$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$export$f484e977a69c6ba6, defaults || {});
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge(this.options, $faa24f22a5163ec6$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $faa24f22a5163ec6$var$uniqueId("splide");
        this.Style = new $faa24f22a5163ec6$var$Style(this.id, this.options);
        this.Direction = $faa24f22a5163ec6$var$Direction(null, null, this.options);
        $faa24f22a5163ec6$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $faa24f22a5163ec6$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $faa24f22a5163ec6$var$queryAll(root, "." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947);
        on($faa24f22a5163ec6$export$d300dc1a2634364b, function() {
            $faa24f22a5163ec6$var$remove($faa24f22a5163ec6$var$child(root, "style"));
        });
        $faa24f22a5163ec6$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $faa24f22a5163ec6$var$push(this.slides, this.contents.map(function(content, index) {
            content = $faa24f22a5163ec6$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $faa24f22a5163ec6$export$72d36ecf3758cb4b : "");
            $faa24f22a5163ec6$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $faa24f22a5163ec6$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $faa24f22a5163ec6$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $faa24f22a5163ec6$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($faa24f22a5163ec6$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $faa24f22a5163ec6$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $faa24f22a5163ec6$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $faa24f22a5163ec6$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $faa24f22a5163ec6$export$93b21159ad85c843,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.type,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $faa24f22a5163ec6$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $faa24f22a5163ec6$export$93b21159ad85c843 + "--nav",
            $faa24f22a5163ec6$export$72d36ecf3758cb4b,
            !this.config.hidden && $faa24f22a5163ec6$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $faa24f22a5163ec6$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $faa24f22a5163ec6$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $faa24f22a5163ec6$var$forOwn(styles, function(value, key) {
            style += " " + $faa24f22a5163ec6$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
        $faa24f22a5163ec6$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $faa24f22a5163ec6$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $faa24f22a5163ec6$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $faa24f22a5163ec6$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $faa24f22a5163ec6$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + '" width="' + $faa24f22a5163ec6$var$SIZE + '" height="' + $faa24f22a5163ec6$var$SIZE + '"><path d="' + (this.options.arrowPath || $faa24f22a5163ec6$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


const $8e05255c34978941$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $8e05255c34978941$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $8e05255c34978941$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($8e05255c34978941$var$e(t) ? t : $8e05255c34978941$var$i(t.parentElement, n));
}, $8e05255c34978941$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $8e05255c34978941$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $8e05255c34978941$var$o = (t, e, i)=>{
    t && $8e05255c34978941$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $8e05255c34978941$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $8e05255c34978941$var$r = {
    passive: !1
};
class $8e05255c34978941$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $8e05255c34978941$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $8e05255c34978941$var$r), this.element.addEventListener("touchmove", this.onMove, $8e05255c34978941$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $8e05255c34978941$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $8e05255c34978941$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $8e05255c34978941$var$a(t)) : [
            new $8e05255c34978941$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $8e05255c34978941$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $8e05255c34978941$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $8e05255c34978941$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $8e05255c34978941$var$r), this.element.removeEventListener("touchmove", this.onMove, $8e05255c34978941$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $8e05255c34978941$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $8e05255c34978941$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $8e05255c34978941$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $8e05255c34978941$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $8e05255c34978941$var$d(i) ? Object.assign(t[e], $8e05255c34978941$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $8e05255c34978941$var$f = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $8e05255c34978941$var$p {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $8e05255c34978941$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $8e05255c34978941$var$f(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $8e05255c34978941$var$f(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $8e05255c34978941$var$f(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($8e05255c34978941$var$p, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.28"
}), Object.defineProperty($8e05255c34978941$var$p, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $8e05255c34978941$var$g extends $8e05255c34978941$var$p {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $8e05255c34978941$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($8e05255c34978941$var$m || ($8e05255c34978941$var$m = {}));
const $8e05255c34978941$var$b = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $8e05255c34978941$var$v = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $8e05255c34978941$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $8e05255c34978941$var$v
}, $8e05255c34978941$var$w = '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>', $8e05255c34978941$var$x = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $8e05255c34978941$var$E = (t, e)=>{
    t && $8e05255c34978941$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $8e05255c34978941$var$S = (t, e)=>{
    t && $8e05255c34978941$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $8e05255c34978941$var$P = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $8e05255c34978941$var$C = 1e5, $8e05255c34978941$var$T = 1e4, $8e05255c34978941$var$M = "mousemove", $8e05255c34978941$var$O = "drag", $8e05255c34978941$var$A = "content";
let $8e05255c34978941$var$L = null, $8e05255c34978941$var$z = null;
class $8e05255c34978941$export$b704d075ddd20210 extends $8e05255c34978941$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $8e05255c34978941$var$z && ($8e05255c34978941$var$z = window.matchMedia("(hover: none)").matches), $8e05255c34978941$var$z;
    }
    get isMobile() {
        return null === $8e05255c34978941$var$L && ($8e05255c34978941$var$L = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $8e05255c34978941$var$L;
    }
    get panMode() {
        return this.options.panMode !== $8e05255c34978941$var$M || this.isTouchDevice ? $8e05255c34978941$var$O : $8e05255c34978941$var$M;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return "auto" === t ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $8e05255c34978941$var$b){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $8e05255c34978941$var$P)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $8e05255c34978941$var$P)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $8e05255c34978941$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $8e05255c34978941$var$n($8e05255c34978941$var$w);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($8e05255c34978941$var$A);
        let i = this.option($8e05255c34978941$var$A) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $8e05255c34978941$var$S(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $8e05255c34978941$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $8e05255c34978941$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $8e05255c34978941$var$m.Error, this.emit("error"));
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $8e05255c34978941$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($8e05255c34978941$var$M, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($8e05255c34978941$var$M, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $8e05255c34978941$var$b)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $8e05255c34978941$var$b)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, f = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? f = h - s : d !== 1 / 0 && s > d && (f = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(f) < 1e-4 && (f = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: f,
            inBounds: !u && !f
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(p.x - u.x), b = Math.abs(p.y - u.y), v = Math.abs(g.x - f.x), y = Math.abs(g.y - f.y);
            r = Math.max(m, v), l = Math.max(b, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $8e05255c34978941$var$M || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $8e05255c34978941$var$b)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $8e05255c34978941$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $8e05255c34978941$var$x(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $8e05255c34978941$var$M && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $8e05255c34978941$var$t(this.targetScale) <= $8e05255c34978941$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $8e05255c34978941$var$h(s[0], s[1]), r = $8e05255c34978941$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $8e05255c34978941$var$c(s[0], s[1]), f = $8e05255c34978941$var$c(n[0], n[1]);
        let p = u ? f / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let b = $8e05255c34978941$var$t(this.targetScale) === $8e05255c34978941$var$t(this.minScale) && this.option("lockAxis");
        if (b && !this.lockedAxis) {
            if ("xy" === b || "y" === b || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = b;
        }
        if ($8e05255c34978941$var$i(e.target, this.content) && (b = "x", this.dragOffset.y = 0), b && "xy" !== b && this.lockedAxis !== b && $8e05255c34978941$var$t(this.targetScale) === $8e05255c34978941$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const v = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (v.xDiff > 0 && g < 0 || v.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * v.xDiff))), "y" !== this.isInfinite && (v.yDiff > 0 && m < 0 || v.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * v.yDiff)))) : (v.xDiff && (g = 0), v.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (p = Math.max(p, w)), y > 1.5 * x && (p = Math.min(p, x)), "y" === this.lockedAxis && $8e05255c34978941$var$t(y) === $8e05255c34978941$var$t(w) && (g = 0), "x" === this.lockedAxis && $8e05255c34978941$var$t(y) === $8e05255c34978941$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: p,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $8e05255c34978941$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $8e05255c34978941$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $8e05255c34978941$var$b)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $8e05255c34978941$var$E(this.container, "is-scaling"), $8e05255c34978941$var$E(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, f = 0, p = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, f = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), f = Math.max(Math.min(f, t), -1 * t));
        }
        u && (h = u / (1 / (1 - p) - 1)), f && (d = f / (1 / (1 - p) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $8e05255c34978941$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $8e05255c34978941$var$t(g) === this.minScale) && (d = f = 0);
        const m = this.dragOffset.x, v = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(v) < y && (h = d = 0, u = f = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (p = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: p
        }), this.emit("decel", u, f, m, v);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $8e05255c34978941$var$M) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $8e05255c34978941$var$P);
        for (const n of $8e05255c34978941$var$b){
            const s = "e" == n || "f" === n ? $8e05255c34978941$var$T : $8e05255c34978941$var$C;
            o[n] = $8e05255c34978941$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, f = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (f = f.parentElement || f), f.style.transform === u) return;
        f.style.transform = u;
        const { contentWidth: p, contentHeight: g } = this.calculateContentDim();
        s.width = p, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $8e05255c34978941$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), f = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: f
        };
        let p = this.option("width") || "auto", g = this.option("height") || "auto";
        "auto" === p && (p = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o)), "auto" === g && (g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o));
        let b = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (b = b.parentElement || b);
        const v = b.getAttribute("style") || "";
        b.style.setProperty("transform", "none", "important"), a && (b.style.width = "", b.style.height = ""), b.offsetHeight;
        const y = o.getBoundingClientRect();
        let w = y.width * n, x = y.height * n, E = 0, S = 0;
        a && (Math.abs(p - w) > 1 || Math.abs(g - x) > 1) && ({ width: w, height: x, top: E, left: S } = ((t, e, i, n)=>{
            const s = i / n;
            return s > t / e ? (i = t, n = t / s) : (i = e * s, n = e), {
                width: i,
                height: n,
                top: .5 * (e - n),
                left: .5 * (t - i)
            };
        })(w, x, p, g)), this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: y.top - r.top + E,
            bottom: r.bottom - y.bottom + E,
            left: y.left - r.left + S,
            right: r.right - y.right + S,
            fitWidth: w,
            fitHeight: x,
            width: w,
            height: x,
            fullWidth: p,
            fullHeight: g
        }), b.style.cssText = v, a && (b.style.width = `${w}px`, b.style.height = `${x}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($8e05255c34978941$var$t(this.targetScale) < $8e05255c34978941$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $8e05255c34978941$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $8e05255c34978941$var$t(o * n, $8e05255c34978941$var$T), f = $8e05255c34978941$var$t(a * n, $8e05255c34978941$var$T), { innerWidth: p, innerHeight: g } = s;
            if (s.width === u && (p = s.width), s.width === f && (g = s.height), e > p) {
                c = .5 * (e - p), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > p && e < p && (r -= .5 * (o - p), c -= .5 * (o - p)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return "auto" !== t ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, fullScale: a, targetScale: r, coverScale: l, maxScale: c, minScale: h } = e;
        let d = {
            toggleMax: r - h < .5 * (c - h) ? c : h,
            toggleCover: r - h < .5 * (l - h) ? l : h,
            toggleZoom: r - h < .5 * (a - h) ? a : h
        }[e.option("click") || ""] || h, u = e.canZoomIn(), f = e.canZoomOut(), p = n === $8e05255c34978941$var$O && !!this.option("touch"), g = f && p;
        if (p && ($8e05255c34978941$var$t(r) < $8e05255c34978941$var$t(h) && !this.panOnlyZoomed && (g = !0), ($8e05255c34978941$var$t(s.width, 1) > $8e05255c34978941$var$t(s.fitWidth, 1) || $8e05255c34978941$var$t(s.height, 1) > $8e05255c34978941$var$t(s.fitHeight, 1)) && (g = !0)), $8e05255c34978941$var$t(s.width * r, 1) < $8e05255c34978941$var$t(s.fitWidth, 1) && (g = !1), n === $8e05255c34978941$var$M && (g = !1), $8e05255c34978941$var$o(i, this.cn("isDraggable"), g), !this.option("zoom")) return;
        let m = u && $8e05255c34978941$var$t(d) > $8e05255c34978941$var$t(r), b = !m && !g && f && $8e05255c34978941$var$t(d) < $8e05255c34978941$var$t(r);
        $8e05255c34978941$var$o(i, this.cn("canZoomIn"), m), $8e05255c34978941$var$o(i, this.cn("canZoomOut"), b);
        for (const t of i.querySelectorAll('[data-panzoom-action="zoomIn"]'))u ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        for (const t of i.querySelectorAll('[data-panzoom-action="zoomOut"]'))f ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        for (const t of i.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            u || f ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
            const e = t.querySelector("g");
            e && (e.style.display = u ? "" : "none");
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $8e05255c34978941$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $8e05255c34978941$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: f } = this, p = f.e, g = f.f, v = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(p, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-p, -g).multiply(v), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $8e05255c34978941$var$b)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $8e05255c34978941$var$t(y[e], $8e05255c34978941$var$T);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $8e05255c34978941$var$M || !1 === d) && !h && this.clampTargetBounds(), u === $8e05255c34978941$var$m.Init ? this.animate() : this.isResting || (this.state = $8e05255c34978941$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $8e05255c34978941$var$m.Init || this.state === $8e05255c34978941$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $8e05255c34978941$var$b)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $8e05255c34978941$var$E(this.container, "is-scaling"), $8e05255c34978941$var$E(this.container, "is-animating"), this.isTicking = !1, this.state = $8e05255c34978941$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $8e05255c34978941$var$S(this.container, "is-animating"), this.isScaling && $8e05255c34978941$var$S(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $8e05255c34978941$var$M || !e) return;
        if ($8e05255c34978941$var$t(this.targetScale) <= $8e05255c34978941$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const f = this.option("mouseMoveFactor");
        f > 1 && (d !== a && (d *= f), u !== r && (u *= f));
        let p = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        p += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: p - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $8e05255c34978941$var$m.Destroy || this.state === $8e05255c34978941$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $8e05255c34978941$var$t(l) < $8e05255c34978941$var$t(r) && $8e05255c34978941$var$t(o) <= $8e05255c34978941$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $8e05255c34978941$var$t(l) > $8e05255c34978941$var$t(a) && $8e05255c34978941$var$t(o) >= $8e05255c34978941$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $8e05255c34978941$var$t(l) !== $8e05255c34978941$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($8e05255c34978941$var$t(this.contentRect.width, 1) < $8e05255c34978941$var$t(this.contentRect.fitWidth, 1) || $8e05255c34978941$var$t(this.targetScale) < $8e05255c34978941$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $8e05255c34978941$var$t(this.targetScale) > $8e05255c34978941$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.fullScale - this.minScale) ? "full" : "fit", t);
    }
    toggleMax(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.maxScale - this.minScale) ? "max" : "fit", t);
    }
    toggleCover(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.coverScale - this.minScale) ? "cover" : "fit", t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = "auto", originX: i = "auto", originY: n = "auto", event: s } = {}) {
        if (this.isContentLoading || this.state === $8e05255c34978941$var$m.Destroy) return;
        const { targetScale: o } = this;
        this.stop();
        let a = 1;
        if (this.panMode === $8e05255c34978941$var$M && (s = this.pmme || s), s || "auto" === i || "auto" === n) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        const r = this.fullScale, l = this.maxScale, c = this.coverScale;
        if ("number" == typeof t) a = t / o || 1;
        else if ("full" === t) a = r / o || 1;
        else if ("cover" === t) a = c / o || 1;
        else if ("max" === t) a = l / o || 1;
        else if ("fit" === t) a = 1 / o || 1;
        else if ("next" === t) {
            let t = [
                1,
                r,
                l
            ].sort((t, e)=>t - e), e = t.findIndex((t)=>t > o + 1e-5);
            a = t[e] / o || 1 / o;
        }
        e = "auto" === e ? a > 1 ? .15 : .25 : e, this.applyChange({
            scale: a,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $8e05255c34978941$var$M && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $8e05255c34978941$var$m.Init && this.state !== $8e05255c34978941$var$m.Destroy) {
            this.stop("current");
            for (const t of $8e05255c34978941$var$b)this.target[t] = $8e05255c34978941$var$P[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $8e05255c34978941$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $8e05255c34978941$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($8e05255c34978941$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$y
}), Object.defineProperty($8e05255c34978941$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $8e05255c34978941$var$k = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $8e05255c34978941$var$I = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $8e05255c34978941$var$D = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $8e05255c34978941$var$F;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($8e05255c34978941$var$F || ($8e05255c34978941$var$F = {}));
const $8e05255c34978941$var$j = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $8e05255c34978941$var$H = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $8e05255c34978941$var$B extends $8e05255c34978941$var$p {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $8e05255c34978941$var$N = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $8e05255c34978941$var$_ extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $8e05255c34978941$var$S(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $8e05255c34978941$var$S(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($8e05255c34978941$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $8e05255c34978941$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$8e05255c34978941$var$E(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $8e05255c34978941$var$S(t, this.cn("isPrev")), $8e05255c34978941$var$S(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $8e05255c34978941$var$S(i, this.cn("isNext")), $8e05255c34978941$var$S(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $8e05255c34978941$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $8e05255c34978941$var$E(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($8e05255c34978941$var$_, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$N
});
const $8e05255c34978941$var$$ = "disabled", $8e05255c34978941$var$W = "next", $8e05255c34978941$var$X = "prev";
class $8e05255c34978941$var$q extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($8e05255c34978941$var$$), s.removeAttribute($8e05255c34978941$var$$), t.isInfinite || (i <= 0 && n.setAttribute($8e05255c34978941$var$$, ""), i >= e - 1 && s.setAttribute($8e05255c34978941$var$$, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $8e05255c34978941$var$S(n, this.cn("button") + " " + this.cn(t === $8e05255c34978941$var$W ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $8e05255c34978941$var$W ? $8e05255c34978941$var$X : $8e05255c34978941$var$W : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $8e05255c34978941$var$S(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($8e05255c34978941$var$W)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($8e05255c34978941$var$X)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($8e05255c34978941$var$q, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $8e05255c34978941$var$Y extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $8e05255c34978941$var$F.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $8e05255c34978941$var$F.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $8e05255c34978941$var$F.Ready || i.state !== $8e05255c34978941$var$F.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $8e05255c34978941$var$F.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($8e05255c34978941$var$Y, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $8e05255c34978941$var$V = {
    Navigation: $8e05255c34978941$var$q,
    Dots: $8e05255c34978941$var$_,
    Sync: $8e05255c34978941$var$Y
}, $8e05255c34978941$var$Z = "animationend", $8e05255c34978941$var$U = "isSelected", $8e05255c34978941$var$G = "slide";
class $8e05255c34978941$export$144901db2ea8e967 extends $8e05255c34978941$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $8e05255c34978941$var$F.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$F.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$8e05255c34978941$var$x(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $8e05255c34978941$var$k(this.slideNext.bind(this), 150), this.slidePrev = $8e05255c34978941$var$k(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $8e05255c34978941$var$u({}, $8e05255c34978941$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $8e05255c34978941$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $8e05255c34978941$var$d(e) && (n += t, $8e05255c34978941$var$u(i, e));
        n === this.bp && this.state !== $8e05255c34978941$var$F.Init || (this.bp = n, this.state === $8e05255c34978941$var$F.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $8e05255c34978941$var$F.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $8e05255c34978941$var$F.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $8e05255c34978941$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $8e05255c34978941$var$F.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $8e05255c34978941$var$S(t, this.cn("container")), $8e05255c34978941$var$o(t, e.isLTR, !this.isRTL), $8e05255c34978941$var$o(t, e.isRTL, this.isRTL), $8e05255c34978941$var$o(t, e.isVertical, !this.isHorizontal), $8e05255c34978941$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $8e05255c34978941$var$S(i, e.viewport), i.append(...$8e05255c34978941$var$I(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $8e05255c34978941$var$S(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$8e05255c34978941$var$I(t, `.${this.cn($8e05255c34978941$var$G)}`)
        ].forEach((t)=>{
            if ($8e05255c34978941$var$x(t)) {
                const e = $8e05255c34978941$var$j({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ]){
            const e = $8e05255c34978941$var$j(t);
            i.push(e);
        }
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $8e05255c34978941$export$b704d075ddd20210(this.viewport, $8e05255c34978941$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($8e05255c34978941$var$H()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e, o)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $8e05255c34978941$var$t(e.pos, 1e3), e.dim = $8e05255c34978941$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = r && !r.parentNode;
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $8e05255c34978941$var$S(r, this.cn($8e05255c34978941$var$G) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r);
            const t = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            o = r.getBoundingClientRect()[s] * t;
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $8e05255c34978941$var$t(o, 1e3),
            gap: $8e05255c34978941$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, f = 0, p = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === f ? "" : `${$8e05255c34978941$var$t(f, 1e3)}px` : n.style[e] = "", p += i.dim + i.gap, u++) : f += i.dim + i.gap;
        }
        if (s && p && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($8e05255c34978941$var$t(i.pos) < $8e05255c34978941$var$t(a) && $8e05255c34978941$var$t(i.pos + i.dim + i.gap) < $8e05255c34978941$var$t(g) && $8e05255c34978941$var$t(g) > $8e05255c34978941$var$t(r - a) && (i.el.style[e] = `${$8e05255c34978941$var$t(f + p, 1e3)}px`), $8e05255c34978941$var$t(i.pos + i.gap) >= $8e05255c34978941$var$t(r - a) && $8e05255c34978941$var$t(i.pos) > $8e05255c34978941$var$t(g + a) && $8e05255c34978941$var$t(g) < $8e05255c34978941$var$t(a) && (i.el.style[e] = `-${$8e05255c34978941$var$t(p, 1e3)}px`));
        }
        let m, b, v = [
            ...this.inTransition
        ];
        if (v.length > 1 && (m = c[v[0]], b = c[v[1]]), m && b) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$8e05255c34978941$var$t(i + (m.pos - b.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $8e05255c34978941$var$S(n, this.cn($8e05255c34978941$var$G)), $8e05255c34978941$var$S(n, t.class), $8e05255c34978941$var$S(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($8e05255c34978941$var$U);
        if (i.classList.contains(n) && ($8e05255c34978941$var$E(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($8e05255c34978941$var$Z);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        const h = t > a ? 1 : -1, d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $8e05255c34978941$var$S(this.container, this.cn("inTransition"));
        const f = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, p = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(p.index), this.createSlideEl(p);
        let g = f.el, m = p.el;
        u || e === $8e05255c34978941$var$G || (e = "fadeFast", g = null);
        const b = this.isRTL ? "next" : "prev", v = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(f.index), f.transition = e, g.addEventListener($8e05255c34978941$var$Z, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? v : b}`)), m && (p.transition = e, m.addEventListener($8e05255c34978941$var$Z, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? b : v}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($8e05255c34978941$var$U);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($8e05255c34978941$var$S(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($8e05255c34978941$var$E(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const t = this.panzoom;
        if (!t || !this.isInfinite) return;
        const e = "x" === this.option("axis") ? "e" : "f", { viewportDim: i, contentDim: n } = this;
        let s = t.current[e], o = t.target[e] - s, a = 0, r = .5 * i, l = n;
        this.isRTL && this.isHorizontal ? (s < -r && (a = -1, s += l), s > l - r && (a = 1, s -= l)) : (s > r && (a = 1, s -= l), s < -l + r && (a = -1, s += l)), a && (t.current[e] = s, t.target[e] = s + o);
    }
    lazyLoadSlide(t) {
        const e = this, i = t && t.el;
        if (!i) return;
        const s = new Set, o = "f-fadeIn";
        i.querySelectorAll("[data-lazy-srcset]").forEach((t)=>{
            t instanceof HTMLImageElement && s.add(t);
        });
        let a = Array.from(i.querySelectorAll("[data-lazy-src]"));
        i.dataset.lazySrc && a.push(i), a.map((t)=>{
            t instanceof HTMLImageElement ? s.add(t) : $8e05255c34978941$var$x(t) && (t.style.backgroundImage = `url('${t.dataset.lazySrc || ""}')`, delete t.dataset.lazySrc);
        });
        const r = (t, i, n)=>{
            n && (n.remove(), n = null), i.complete && (i.classList.add(o), setTimeout(()=>{
                i.classList.remove(o);
            }, 350), i.style.visibility = ""), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (e.updateMetrics(), e.setViewportHeight()), this.emit("load", t);
        };
        for (const e of s){
            let i = null;
            e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.style.visibility = "hidden", e.addEventListener("error", ()=>{
                r(t, e, i);
            }), e.addEventListener("load", ()=>{
                r(t, e, i);
            }), setTimeout(()=>{
                e.parentNode && t.el && (e.complete ? r(t, e, i) : (i = $8e05255c34978941$var$n($8e05255c34978941$var$w), e.parentNode.insertBefore(i, e)));
            }, 300);
        }
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        const u = this.option("dragFree");
        let f = this.page, p = o && a ? 1 : -1;
        const g = t.target[r] * p, m = t.current[r] * p;
        let { pageIndex: b } = this.getPageFromPosition(g), { pageIndex: v } = this.getPageFromPosition(m);
        u ? this.onChange(b) : (Math.abs(d) > 5 ? (l[f].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (f = v), f = o && a ? d < 0 ? f - 1 : f + 1 : d < 0 ? f + 1 : f - 1) : f = 0 === n && 0 === s ? f : v, this.slideTo(f, {
            transition: !1,
            friction: t.option("decelFriction")
        }));
    }
    onClick(t) {
        const e = t.target, i = e && $8e05255c34978941$var$x(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $8e05255c34978941$var$F.Init, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $8e05255c34978941$var$F.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition(this.panzoom.current[this.isHorizontal ? "e" : "f"]);
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $8e05255c34978941$var$E(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($8e05255c34978941$var$Z, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($8e05255c34978941$var$j(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e, this.removeSlideEl(this.slides[t], !0), this.slides.splice(t, 1);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        this.updateMetrics(), this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $8e05255c34978941$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $8e05255c34978941$var$t(n, 1e3), o = $8e05255c34978941$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $8e05255c34978941$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect["e" === this.axis ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $8e05255c34978941$var$F.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $8e05255c34978941$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $8e05255c34978941$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $8e05255c34978941$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { contentDim: n, viewportDim: s, pages: o, page: a } = this;
        n = n + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
        let r = 0;
        r = this.panzoom && this.panzoom.state !== $8e05255c34978941$var$m.Init && this.panzoom.state !== $8e05255c34978941$var$m.Destroy ? -1 * this.panzoom.current[this.axis] : o[a] && o[a].pos || 0, this.isInfinite && (r -= Math.floor(r / n) * n), this.isRTL && this.isHorizontal && (r *= -1);
        const l = r - s * t, c = r + s * (t + 1), h = this.isInfinite ? [
            -1,
            0,
            1
        ] : [
            0
        ];
        for (const t of this.slides)for (const e of h){
            const s = t.pos + e * n, o = s + t.dim + t.gap;
            s < c && o > l && i.add(t);
        }
        return i;
    }
    getPageFromPosition(t) {
        var e;
        const { viewportDim: i, contentDim: n } = this, s = this.pages.length, o = this.slides.length, a = this.slides[o - 1];
        let r = 0, l = 0, c = 0;
        const h = this.option("center");
        h && (t += .5 * i), this.isInfinite || (t = Math.max((null === (e = this.slides[0]) || void 0 === e ? void 0 : e.pos) || 0, Math.min(t, a.pos)));
        const d = n + a.gap;
        c = Math.floor(t / d) || 0, t -= c * d;
        let u = a, f = this.slides.find((e)=>{
            const i = t + (u && !h ? .5 * u.dim : 0);
            return u = e, e.pos <= i && e.pos + e.dim + e.gap > i;
        });
        return f || (f = a), l = this.getPageForSlide(f.index), r = l + c * s, {
            page: r,
            pageIndex: l
        };
    }
    destroy() {
        if ([
            $8e05255c34978941$var$F.Destroy
        ].includes(this.state)) return;
        this.state = $8e05255c34978941$var$F.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($8e05255c34978941$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$export$b704d075ddd20210
}), Object.defineProperty($8e05255c34978941$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$D
}), Object.defineProperty($8e05255c34978941$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$V
});
const $8e05255c34978941$var$J = function(t) {
    if (!$8e05255c34978941$var$x(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $8e05255c34978941$var$Q = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $8e05255c34978941$var$tt;
const $8e05255c34978941$var$et = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $8e05255c34978941$var$it = (t)=>{
    if (t && $8e05255c34978941$var$Q) {
        void 0 === $8e05255c34978941$var$tt && document.createElement("div").focus({
            get preventScroll () {
                return $8e05255c34978941$var$tt = !0, !1;
            }
        });
        try {
            if ($8e05255c34978941$var$tt) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $8e05255c34978941$var$nt = {
    dragToClose: !0,
    hideScrollbar: !0,
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    contentClick: "toggleZoom",
    contentDblClick: !1,
    backdropClick: "close",
    animated: !0,
    idle: 3500,
    showClass: "f-zoomInUp",
    hideClass: "f-fadeOut",
    commonCaption: !1,
    parentEl: null,
    startIndex: 0,
    l10n: Object.assign(Object.assign({}, $8e05255c34978941$var$v), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    defaultType: "image",
    defaultDisplay: "block",
    autoFocus: !0,
    trapFocus: !0,
    placeFocusBack: !0,
    closeButton: "auto",
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    Fullscreen: {
        autoStart: !1
    },
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    wheel: "zoom"
};
var $8e05255c34978941$var$st, $8e05255c34978941$var$ot;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($8e05255c34978941$var$st || ($8e05255c34978941$var$st = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($8e05255c34978941$var$ot || ($8e05255c34978941$var$ot = {}));
const $8e05255c34978941$var$at = ()=>{
    queueMicrotask(()=>{
        (()=>{
            const { slug: t, index: e } = $8e05255c34978941$var$rt.parseURL(), i = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
            if (i && !1 !== i.option("Hash")) {
                const n = i.carousel;
                if (t && n) {
                    for (let e of n.slides)if (e.slug && e.slug === t) return n.slideTo(e.index);
                    if (t === i.option("slug")) return n.slideTo(e - 1);
                    const s = i.getSlide(), o = s && s.triggerEl && s.triggerEl.dataset;
                    if (o && o.fancybox === t) return n.slideTo(e - 1);
                }
                $8e05255c34978941$var$rt.hasSilentClose = !0, i.close();
            }
            $8e05255c34978941$var$rt.startFromUrl();
        })();
    });
};
class $8e05255c34978941$var$rt extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "origHash", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onChange() {
        const t = this.instance, e = t.carousel;
        this.timer && clearTimeout(this.timer);
        const i = t.getSlide();
        if (!e || !i) return;
        const n = t.isOpeningSlide(i), s = new URL(document.URL).hash;
        let o, a = i.slug || void 0, r = i.triggerEl || void 0;
        o = a || this.instance.option("slug"), !o && r && r.dataset && (o = r.dataset.fancybox);
        let l = "";
        o && "true" !== o && (l = "#" + o + (!a && e.slides.length > 1 ? "-" + (i.index + 1) : "")), n && (this.origHash = s !== l ? s : ""), l && s !== l && (this.timer = setTimeout(()=>{
            try {
                t.state === $8e05255c34978941$var$st.Ready && window.history[n ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + l);
            } catch (t) {}
        }, 300));
    }
    onClose() {
        if (this.timer && clearTimeout(this.timer), !0 !== $8e05255c34978941$var$rt.hasSilentClose) try {
            window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
        } catch (t) {}
    }
    attach() {
        const t = this.instance;
        t.on([
            "Carousel.ready",
            "Carousel.change"
        ], this.onChange), t.on("close", this.onClose);
    }
    detach() {
        const t = this.instance;
        t.off([
            "Carousel.ready",
            "Carousel.change"
        ], this.onChange), t.off("close", this.onClose);
    }
    static parseURL() {
        const t = window.location.hash.slice(1), e = t.split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
        return {
            hash: t,
            slug: e.join("-"),
            index: n
        };
    }
    static startFromUrl() {
        if ($8e05255c34978941$var$rt.hasSilentClose = !1, $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance() || !1 === $8e05255c34978941$export$cb45b08d97cdc4fd.defaults.Hash) return;
        const { hash: t, slug: e, index: i } = $8e05255c34978941$var$rt.parseURL();
        if (!e) return;
        let n = document.querySelector(`[data-slug="${t}"]`);
        if (n && n.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })), $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance()) return;
        const s = document.querySelectorAll(`[data-fancybox="${e}"]`);
        s.length && (n = s[i - 1], n && n.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })));
    }
    static destroy() {
        window.removeEventListener("hashchange", $8e05255c34978941$var$at, !1);
    }
}
function $8e05255c34978941$var$lt() {
    window.addEventListener("hashchange", $8e05255c34978941$var$at, !1), setTimeout(()=>{
        $8e05255c34978941$var$rt.startFromUrl();
    }, 500);
}
Object.defineProperty($8e05255c34978941$var$rt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
}), Object.defineProperty($8e05255c34978941$var$rt, "hasSilentClose", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: !1
}), $8e05255c34978941$var$Q && (/complete|interactive|loaded/.test(document.readyState) ? $8e05255c34978941$var$lt() : document.addEventListener("DOMContentLoaded", $8e05255c34978941$var$lt));
const $8e05255c34978941$var$ct = "is-zooming-in";
class $8e05255c34978941$var$ht extends $8e05255c34978941$var$B {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $8e05255c34978941$var$E(this.instance.container, $8e05255c34978941$var$ct);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $8e05255c34978941$var$m.Init || a.state === $8e05255c34978941$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $8e05255c34978941$var$st.CustomClosing, i.classList.remove($8e05255c34978941$var$ct), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${window.scrollY}px`,
            left: `${window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: f } = l;
        if (f) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: f ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $8e05255c34978941$var$S(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $8e05255c34978941$var$S(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($8e05255c34978941$var$S(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $8e05255c34978941$var$ot.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $8e05255c34978941$var$n(l)), !l || !$8e05255c34978941$var$x(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $8e05255c34978941$var$S(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $8e05255c34978941$export$b704d075ddd20210(r, $8e05255c34978941$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: a.optionFor(t, "width", "auto"),
                height: a.optionFor(t, "height", "auto"),
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, f = ()=>{
                t.state !== $8e05255c34978941$var$ot.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, p = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($8e05255c34978941$var$E(s, $8e05255c34978941$var$ct), a.style.opacity = "", t.off("endAnimation", p), t.off("touchStart", p), t.off("afterTransform", f), e(t));
            };
            o.on("endAnimation", p), o.on("touchStart", p), o.on("afterTransform", f), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $8e05255c34978941$var$S(s, $8e05255c34978941$var$ct), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        var e;
        const { el: i, imageEl: n, thumbEl: s, panzoom: o } = t;
        if (!i || !n || !s || !o || $8e05255c34978941$var$J(s) < 3 || !this.optionFor(t, "zoom") || this.instance.state === $8e05255c34978941$var$st.Destroy) return !1;
        if (1 !== ((null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1)) return !1;
        let { top: a, left: r, width: l, height: c } = s.getBoundingClientRect(), { top: h, left: d, fitWidth: u, fitHeight: f } = o.contentRect;
        if (!(l && c && u && f)) return !1;
        const p = o.container.getBoundingClientRect();
        d += p.left, h += p.top;
        const g = -1 * (d + .5 * u - (r + .5 * l)), m = -1 * (h + .5 * f - (a + .5 * c)), b = l / u;
        let v = this.option("zoomOpacity") || !1;
        return "auto" === v && (v = Math.abs(l / c - u / f) > .1), {
            x: g,
            y: m,
            scale: b,
            opacity: v
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($8e05255c34978941$var$ht, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $8e05255c34978941$var$dt = "html", $8e05255c34978941$var$ut = "image", $8e05255c34978941$var$ft = "map", $8e05255c34978941$var$pt = "youtube", $8e05255c34978941$var$gt = "vimeo", $8e05255c34978941$var$mt = "html5video", $8e05255c34978941$var$bt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i.toString();
        "t" === t ? s.set("start", parseInt(e).toString()) : s.set(t, e);
    }
    let o = s.toString(), a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $8e05255c34978941$var$vt = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $8e05255c34978941$var$yt = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $8e05255c34978941$var$wt extends $8e05255c34978941$var$B {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== n.style.display && (n.style.display = "none"), s.parentNode && s.parentNode.insertBefore(n, s), s.remove(), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $8e05255c34978941$var$ot.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $8e05255c34978941$var$mt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $8e05255c34978941$var$gt ? o = {
            method: "pause",
            value: "true"
        } : i.type === $8e05255c34978941$var$pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $8e05255c34978941$var$st.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($8e05255c34978941$var$x(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $8e05255c34978941$var$pt || e === $8e05255c34978941$var$gt) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($8e05255c34978941$var$dt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $8e05255c34978941$var$mt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $8e05255c34978941$var$pt && t.type !== $8e05255c34978941$var$gt) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $8e05255c34978941$var$pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $8e05255c34978941$var$pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $8e05255c34978941$var$dt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $8e05255c34978941$var$pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $8e05255c34978941$var$bt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $8e05255c34978941$var$pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $8e05255c34978941$var$bt(e, this.optionFor(t, $8e05255c34978941$var$gt)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $8e05255c34978941$var$gt;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $8e05255c34978941$var$yt.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $8e05255c34978941$var$mt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $8e05255c34978941$var$ut : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $8e05255c34978941$var$ft) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $8e05255c34978941$var$ft), i = i || this.instance.option("defaultType"), t.type = i, i === $8e05255c34978941$var$ut && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $8e05255c34978941$var$dt:
                    this.instance.setContent(t, e);
                    break;
                case $8e05255c34978941$var$mt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $8e05255c34978941$var$ft:
                case $8e05255c34978941$var$pt:
                case $8e05255c34978941$var$gt:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $8e05255c34978941$var$pt,
            $8e05255c34978941$var$gt,
            $8e05255c34978941$var$mt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($8e05255c34978941$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$vt
});
const $8e05255c34978941$var$xt = "play", $8e05255c34978941$var$Et = "pause", $8e05255c34978941$var$St = "ready";
class $8e05255c34978941$var$Pt extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$St
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $8e05255c34978941$var$St;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        var t;
        (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) || (this.removeProgressBar(), this.pause());
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $8e05255c34978941$var$S(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $8e05255c34978941$var$xt, $8e05255c34978941$var$S(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $8e05255c34978941$var$St) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $8e05255c34978941$var$St, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $8e05255c34978941$var$E(i, "has-autoplay"), e !== $8e05255c34978941$var$St && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $8e05255c34978941$var$xt && (t.state = $8e05255c34978941$var$Et, t.clear(), t.emit($8e05255c34978941$var$Et));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $8e05255c34978941$var$xt) {
                if (t.state === $8e05255c34978941$var$Et && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $8e05255c34978941$var$xt || this.state === $8e05255c34978941$var$Et ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($8e05255c34978941$var$Pt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $8e05255c34978941$var$Ct extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $8e05255c34978941$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $8e05255c34978941$var$ot.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $8e05255c34978941$var$ot.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $8e05255c34978941$var$Pt
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($8e05255c34978941$var$Ct, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $8e05255c34978941$var$Tt = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $8e05255c34978941$var$Mt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($8e05255c34978941$var$Mt || ($8e05255c34978941$var$Mt = {}));
const $8e05255c34978941$var$Ot = "isResting", $8e05255c34978941$var$At = "thumbWidth", $8e05255c34978941$var$Lt = "thumbHeight", $8e05255c34978941$var$zt = "thumbClipWidth";
let $8e05255c34978941$var$Rt = class extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$Mt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$8e05255c34978941$var$zt] = parseFloat(i[$8e05255c34978941$var$zt] || "") || e[$8e05255c34978941$var$zt] || 0, e[$8e05255c34978941$var$Lt] = parseFloat(i.thumbHeight || "") || e[$8e05255c34978941$var$Lt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $8e05255c34978941$var$E(e, this.cn($8e05255c34978941$var$Ot));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$8e05255c34978941$var$zt] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $8e05255c34978941$var$o(e, this.cn($8e05255c34978941$var$Ot), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$8e05255c34978941$var$At] = t[$8e05255c34978941$var$zt] && t[$8e05255c34978941$var$Lt] ? Math.round(this[$8e05255c34978941$var$Lt] * (t[$8e05255c34978941$var$zt] / t[$8e05255c34978941$var$Lt])) : this[$8e05255c34978941$var$At]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$8e05255c34978941$var$At] = e("width") || 40, this[$8e05255c34978941$var$zt] = e("clip-width") || 40, this[$8e05255c34978941$var$Lt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $8e05255c34978941$var$Mt.Init) return;
        if (t.isDisabled()) return;
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = document.createElement("div");
        $8e05255c34978941$var$S(o, t.cn("container")), $8e05255c34978941$var$S(o, `is-${s}`);
        const a = t.option("parentEl");
        a ? a.appendChild(o) : i.after(o), $8e05255c34978941$var$S(i, t.cn("hasThumbs")), t.container = o, t.updateProps();
        const r = document.createElement("div");
        $8e05255c34978941$var$S(r, t.cn("track")), o.appendChild(r), t.track = r;
        const l = $8e05255c34978941$var$u({}, {
            track: r,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), c = new e.constructor(o, l);
        c.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), c.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), c.on("refresh", ()=>{
            t.shiftModern();
        }), c.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = c, t.state = $8e05255c34978941$var$Mt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$8e05255c34978941$var$zt], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [f, p] = o(c + l, h);
        u && p ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - p.getBoundingClientRect().left) ? d : f, a === n && (a = a === d ? f : d)) : u ? a = d : p && (a = f), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$8e05255c34978941$var$At], a = i[$8e05255c34978941$var$zt], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), f = n.getProgress(t, !1, !0), p = 0, g = c + l + r;
        const m = d < 0 && d > -1, b = u > 0 && u < 1;
        return 0 === t ? (p = g * Math.abs(d), b && 1 === d && (p -= g * Math.abs(u))) : t === h ? (p = g * Math.abs(u) * -1, m && -1 === u && (p += g * Math.abs(d))) : m || b ? (p = -1 * g, p += g * Math.abs(d), p += g * (1 - Math.abs(u))) : p = g * f, p;
    }
    setProps(e) {
        const i = this;
        if (!i.isModern) return;
        const { instance: n } = i, s = i.carousel;
        if (n && s) {
            const o = s.slides[e].el;
            if (o && o.childNodes.length) {
                let s = $8e05255c34978941$var$t(1 - Math.abs(n.getProgress(e))), a = $8e05255c34978941$var$t(i.getShift(e));
                o.style.setProperty("--progress", s ? s + "" : ""), o.style.setProperty("--shift", a + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $8e05255c34978941$var$m.Init || n.state === $8e05255c34978941$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$8e05255c34978941$var$zt] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $8e05255c34978941$var$Mt.Init, $8e05255c34978941$var$E(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $8e05255c34978941$var$F.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($8e05255c34978941$var$Rt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$Tt
});
const $8e05255c34978941$var$kt = Object.assign(Object.assign({}, $8e05255c34978941$var$Tt), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $8e05255c34978941$var$It = "is-masked", $8e05255c34978941$var$Dt = "aria-hidden";
class $8e05255c34978941$var$Ft extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $8e05255c34978941$var$S(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $8e05255c34978941$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $8e05255c34978941$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $8e05255c34978941$var$Rt
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $8e05255c34978941$var$Mt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $8e05255c34978941$var$Mt.Hidden ? (t.state = $8e05255c34978941$var$Mt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($8e05255c34978941$var$Dt), e.classList.remove($8e05255c34978941$var$It), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($8e05255c34978941$var$It), e.setAttribute($8e05255c34978941$var$Dt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $8e05255c34978941$var$st.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($8e05255c34978941$var$Ft, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$kt
});
const $8e05255c34978941$var$jt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $8e05255c34978941$var$Ht;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($8e05255c34978941$var$Ht || ($8e05255c34978941$var$Ht = {}));
const $8e05255c34978941$var$Bt = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $8e05255c34978941$var$Nt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
};
class $8e05255c34978941$var$_t extends $8e05255c34978941$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$Ht.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $8e05255c34978941$var$S(i, "fancybox__toolbar__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $8e05255c34978941$var$S(r, "is-absolute"), this.state = $8e05255c34978941$var$Ht.Ready, this.onRefresh();
        } else this.state = $8e05255c34978941$var$Ht.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $8e05255c34978941$var$x(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $8e05255c34978941$var$ot.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t, i = document.createElement("div");
        return $8e05255c34978941$var$S(i, "fancybox__toolbar"), e.prepend(i), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $8e05255c34978941$var$S(t, "has-toolbar"), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !e.fsAPI) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $8e05255c34978941$var$jt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $8e05255c34978941$var$jt[t]) {
            const e = $8e05255c34978941$var$jt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $8e05255c34978941$var$S(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($8e05255c34978941$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $8e05255c34978941$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($8e05255c34978941$var$Nt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $8e05255c34978941$var$Ht.Disabled;
        const e = this.instance.container;
        e && $8e05255c34978941$var$E(e, "has-toolbar");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($8e05255c34978941$var$_t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$Bt
});
const $8e05255c34978941$var$$t = {
    Hash: $8e05255c34978941$var$rt,
    Html: $8e05255c34978941$var$wt,
    Images: $8e05255c34978941$var$ht,
    Slideshow: $8e05255c34978941$var$Ct,
    Thumbs: $8e05255c34978941$var$Ft,
    Toolbar: $8e05255c34978941$var$_t
}, $8e05255c34978941$var$Wt = "with-fancybox", $8e05255c34978941$var$Xt = "hide-scrollbar", $8e05255c34978941$var$qt = "--fancybox-scrollbar-compensate", $8e05255c34978941$var$Yt = "--fancybox-body-margin", $8e05255c34978941$var$Vt = "is-using-tab", $8e05255c34978941$var$Zt = "is-animated", $8e05255c34978941$var$Ut = "is-compact", $8e05255c34978941$var$Gt = "is-loading", $8e05255c34978941$var$Kt = "has-caption", $8e05255c34978941$var$Jt = "disabled", $8e05255c34978941$var$Qt = "tabindex", $8e05255c34978941$var$te = "download", $8e05255c34978941$var$ee = "href", $8e05255c34978941$var$ie = "src", $8e05255c34978941$var$ne = (t)=>"string" == typeof t, $8e05255c34978941$var$se = function() {
    var t = window.getSelection();
    return t && "Range" === t.type;
};
let $8e05255c34978941$var$oe = null, $8e05255c34978941$var$ae = null;
const $8e05255c34978941$var$re = new Map;
let $8e05255c34978941$var$le = 0;
class $8e05255c34978941$export$cb45b08d97cdc4fd extends $8e05255c34978941$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $8e05255c34978941$var$st.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "fsAPI", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.fsAPI = (()=>{
            let t, e = "", i = "", n = "";
            return document.fullscreenEnabled ? (e = "requestFullscreen", i = "exitFullscreen", n = "fullscreenElement") : document.webkitFullscreenEnabled && (e = "webkitRequestFullscreen", i = "webkitExitFullscreen", n = "webkitFullscreenElement"), e && (t = {
                request: function(t) {
                    return "webkitRequestFullscreen" === e ? t[e](Element.ALLOW_KEYBOARD_INPUT) : t[e]();
                },
                exit: function() {
                    return document[n] && document[i]();
                },
                isFullscreen: function() {
                    return document[n];
                }
            }), t;
        })(), this.id = e.id || ++$8e05255c34978941$var$le, $8e05255c34978941$var$re.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $8e05255c34978941$var$st.Destroy) return;
        this.state = $8e05255c34978941$var$st.Init, this.attachPlugins(Object.assign(Object.assign({}, $8e05255c34978941$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$8e05255c34978941$var$Q) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($8e05255c34978941$var$Xt)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($8e05255c34978941$var$qt, `${n}px`), s && e.style.setProperty($8e05255c34978941$var$Yt, `${s}px`), e.classList.add($8e05255c34978941$var$Xt);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $8e05255c34978941$var$st.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute("aria-hidden", "false");
            }, 16);
        }, e = this.fsAPI;
        this.option("Fullscreen.autoStart") && e && !e.isFullscreen() ? e.request(this.container).then(()=>t()).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $8e05255c34978941$var$n(this.localize(this.option("tpl.main") || ""));
        s && (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($8e05255c34978941$var$Ut, this.isCompact), $8e05255c34978941$var$S(s, this.option("mainClass") || ""), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $8e05255c34978941$var$S(document.documentElement, $8e05255c34978941$var$Wt), $8e05255c34978941$var$oe && $8e05255c34978941$var$ae || ($8e05255c34978941$var$oe = document.createElement("span"), $8e05255c34978941$var$S($8e05255c34978941$var$oe, "fancybox-focus-guard"), $8e05255c34978941$var$oe.setAttribute($8e05255c34978941$var$Qt, "0"), $8e05255c34978941$var$oe.setAttribute("aria-hidden", "true"), $8e05255c34978941$var$oe.setAttribute("aria-label", "Focus guard"), $8e05255c34978941$var$ae = $8e05255c34978941$var$oe.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($8e05255c34978941$var$oe, s), null === (e = s.parentElement) || void 0 === e || e.append($8e05255c34978941$var$ae)), s.addEventListener("mousedown", ()=>{
            $8e05255c34978941$var$E(s, $8e05255c34978941$var$Vt);
        }), this.option("animated") && ($8e05255c34978941$var$S(s, $8e05255c34978941$var$Zt), setTimeout(()=>{
            this.isClosing() || $8e05255c34978941$var$E(s, $8e05255c34978941$var$Zt);
        }, 350)), this.emit("initLayout"));
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $8e05255c34978941$export$144901db2ea8e967(n, $8e05255c34978941$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $8e05255c34978941$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $8e05255c34978941$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($8e05255c34978941$var$Jt), i.removeAttribute($8e05255c34978941$var$Qt)) : (i.setAttribute($8e05255c34978941$var$Jt, ""), i.setAttribute($8e05255c34978941$var$Qt, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($8e05255c34978941$var$Jt), i.removeAttribute($8e05255c34978941$var$Qt)) : (i.setAttribute($8e05255c34978941$var$Jt, ""), i.setAttribute($8e05255c34978941$var$Qt, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$8e05255c34978941$var$ne(i[$8e05255c34978941$var$ie]) || (n = i[$8e05255c34978941$var$ie]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($8e05255c34978941$var$Jt), t.removeAttribute($8e05255c34978941$var$Qt), t.setAttribute($8e05255c34978941$var$ee, n), t.setAttribute($8e05255c34978941$var$te, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($8e05255c34978941$var$Jt, ""), t.setAttribute($8e05255c34978941$var$Qt, "-1"), t.removeAttribute($8e05255c34978941$var$ee), t.removeAttribute($8e05255c34978941$var$te));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e, i;
        const { container: n, isCompact: s } = this;
        if (!n || this.isClosing()) return;
        !s && this.option("idle") && this.resetIdle();
        const o = t.composedPath()[0];
        if (o.closest(".f-spinner") || o.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (o.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (o.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        const a = document.activeElement;
        if ($8e05255c34978941$var$se() && a && n.contains(a)) return;
        if (o === (null === (e = this.carousel) || void 0 === e ? void 0 : e.container)) return;
        if (s && "image" === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let r = !1;
        if (o.closest(".fancybox__content")) {
            if (a) {
                if (a.closest("[contenteditable]")) return;
                o.matches($8e05255c34978941$var$et) || a.blur();
            }
            if ($8e05255c34978941$var$se()) return;
            r = this.option("contentClick");
        } else o.closest(".fancybox__carousel") && !o.matches($8e05255c34978941$var$et) && (r = this.option("backdropClick"));
        "close" === r ? (t.preventDefault(), this.close(t)) : "next" === r ? (t.preventDefault(), this.next()) : "prev" === r && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($8e05255c34978941$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $8e05255c34978941$var$x(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $8e05255c34978941$var$S(this.container, $8e05255c34978941$var$Vt) : $8e05255c34978941$var$E(this.container, $8e05255c34978941$var$Vt), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($8e05255c34978941$var$Ut, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $8e05255c34978941$var$Ht.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $8e05255c34978941$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $8e05255c34978941$var$S(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $8e05255c34978941$var$E(s, $8e05255c34978941$var$Kt);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $8e05255c34978941$var$E(t.el, $8e05255c34978941$var$Kt), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $8e05255c34978941$var$S(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $8e05255c34978941$var$S(r, $8e05255c34978941$var$Kt), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $8e05255c34978941$var$S(c, n);
                (this.footer || s).prepend(c);
            }
            $8e05255c34978941$var$S(s, $8e05255c34978941$var$Kt), this.caption = c;
        }
        c && (c.innerHTML = "", $8e05255c34978941$var$ne(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = this.getSlide();
        if (!s || !(null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport)) return;
        if (!t && i && s.contains(i)) return;
        const a = o && o.state === $8e05255c34978941$var$ot.Ready ? o.el : null;
        if (!a || a.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const r = Array.from(s.querySelectorAll($8e05255c34978941$var$et));
        let l = [], c = null;
        for (let t of r){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = a && a.contains(t), n = !this.carousel.viewport.contains(t);
            if (t === s || (i || n) && !e) {
                l.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && c || (c = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let h = null;
        t ? (!n || l.indexOf(n) < 0) && (h = c || s, l.length && (i === $8e05255c34978941$var$ae ? h = l[0] : this.lastFocus !== s && i !== $8e05255c34978941$var$oe || (h = l[l.length - 1]))) : h = o && "image" === o.type ? s : c || s, h && $8e05255c34978941$var$it(h), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $8e05255c34978941$var$E(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $8e05255c34978941$var$S(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($8e05255c34978941$var$x(e) ? o = e : (o = $8e05255c34978941$var$n(e + ""), $8e05255c34978941$var$x(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $8e05255c34978941$var$x(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $8e05255c34978941$var$x(o) ? ($8e05255c34978941$var$S(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), "none" !== o.style.display && "none" !== getComputedStyle(o).getPropertyValue("display") || (o.style.display = t.display || this.option("defaultDisplay") || "flex"), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $8e05255c34978941$var$ot.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $8e05255c34978941$var$ot.Ready, this.emit("done", t), $8e05255c34978941$var$S(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && (this.option("autoFocus") ? this.focus() : this.checkFocus());
        }), this.isOpeningSlide(t) && !this.isCompact && this.option("idle") && this.setIdle());
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $8e05255c34978941$var$ot.Loading;
        const e = t.el;
        if (!e) return;
        $8e05255c34978941$var$S(e, $8e05255c34978941$var$Gt), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $8e05255c34978941$var$ot.Loading) {
                let i = $8e05255c34978941$var$n($8e05255c34978941$var$w);
                t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($8e05255c34978941$var$E(e, $8e05255c34978941$var$Gt), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $8e05255c34978941$var$ot.Loading && (this.emit("loaded", t), t.state = $8e05255c34978941$var$ot.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($8e05255c34978941$var$E(e, "has-error"), $8e05255c34978941$var$E(e, "has-unknown"), $8e05255c34978941$var$E(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = this.fsAPI, s = ()=>{
            this.proceedClose(t, e);
        };
        n && n.isFullscreen() === this.container ? Promise.resolve(n.exit()).then(()=>s()) : s();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $8e05255c34978941$var$S(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $8e05255c34978941$var$E(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        const t = this.fsAPI;
        t && (t.isFullscreen() ? t.exit() : this.container && t.request(this.container));
    }
    isClosing() {
        return [
            $8e05255c34978941$var$st.Closing,
            $8e05255c34978941$var$st.CustomClosing,
            $8e05255c34978941$var$st.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $8e05255c34978941$var$st.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($8e05255c34978941$var$J(r) ? $8e05255c34978941$var$it(r) : r.focus()), s && ($8e05255c34978941$var$S(s, "is-closing"), s.setAttribute("aria-hidden", "true"), this.option("animated") && $8e05255c34978941$var$S(s, $8e05255c34978941$var$Zt), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $8e05255c34978941$var$ot.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        this.emit("close", t), this.state !== $8e05255c34978941$var$st.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $8e05255c34978941$var$st.Destroy) return;
        this.state = $8e05255c34978941$var$st.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $8e05255c34978941$var$re.delete(this.id);
        const i = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($8e05255c34978941$var$oe && ($8e05255c34978941$var$oe.remove(), $8e05255c34978941$var$oe = null), $8e05255c34978941$var$ae && ($8e05255c34978941$var$ae.remove(), $8e05255c34978941$var$ae = null), $8e05255c34978941$var$E(document.documentElement, $8e05255c34978941$var$Wt), (()=>{
            if (!$8e05255c34978941$var$Q) return;
            const t = document, e = t.body;
            e.classList.remove($8e05255c34978941$var$Xt), e.style.setProperty($8e05255c34978941$var$Yt, ""), t.documentElement.style.setProperty($8e05255c34978941$var$qt, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$8e05255c34978941$var$Q) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $8e05255c34978941$var$ne(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $8e05255c34978941$var$ne(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$8e05255c34978941$var$x(n)) return;
        s = s || "[data-fancybox]";
        const a = $8e05255c34978941$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $8e05255c34978941$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $8e05255c34978941$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($8e05255c34978941$var$ne(t) ? (i = document.body, n = t) : (i = t, $8e05255c34978941$var$ne(e) && (n = e)), !i) return;
        const s = $8e05255c34978941$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($8e05255c34978941$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $8e05255c34978941$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $8e05255c34978941$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $8e05255c34978941$export$cb45b08d97cdc4fd.fromEvent);
        $8e05255c34978941$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$8e05255c34978941$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $8e05255c34978941$var$u({}, $8e05255c34978941$var$nt, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const f = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
        return f && f.options.triggerEl && r.indexOf(f.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $8e05255c34978941$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($8e05255c34978941$var$ne(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $8e05255c34978941$var$ne(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $8e05255c34978941$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $8e05255c34978941$var$u({}, a.get(s) || {}, o), !!o && $8e05255c34978941$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $8e05255c34978941$var$u({}, $8e05255c34978941$var$nt, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$8e05255c34978941$var$ie] || n.getAttribute($8e05255c34978941$var$ee) || n.getAttribute("currentSrc") || n.getAttribute($8e05255c34978941$var$ie) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$8e05255c34978941$var$ie] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$8e05255c34978941$var$ie] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $8e05255c34978941$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $8e05255c34978941$var$re.get(t);
        return Array.from($8e05255c34978941$var$re.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $8e05255c34978941$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $8e05255c34978941$var$re.values())t.close(...e);
        else {
            const t = $8e05255c34978941$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($8e05255c34978941$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.28"
}), Object.defineProperty($8e05255c34978941$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$nt
}), Object.defineProperty($8e05255c34978941$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $8e05255c34978941$var$$t
}), Object.defineProperty($8e05255c34978941$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});


var $428fcb2015744f49$exports = {};
(function(global, factory) {
    $428fcb2015744f49$exports = factory();
})($428fcb2015744f49$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


const $2ad374ddd6de712e$var$mapIcon = "https://dentalimplantsgps.com/wp-content/themes/bridge-child/resources/images/gps_map_icon_c.png";
var $2ad374ddd6de712e$var$ready = (callback)=>{
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
$2ad374ddd6de712e$var$ready(()=>{
    const rootfontsize = getComputedStyle(document.documentElement).fontSize;
    // desktop hamburger menu button
    document.querySelector(".dsktphamburger").addEventListener("click", (e)=>{
        const main_menu = document.getElementsByClassName("main_menu")[0];
        if (main_menu) main_menu.classList.toggle("active");
    });
    // desktop close menu button
    document.querySelector(".closenav").addEventListener("click", (e)=>{
        const main_menu = document.getElementsByClassName("main_menu")[0];
        if (main_menu) main_menu.classList.toggle("active");
    });
    //desktop mega menu subheads, prevent click
    document.querySelector(".sub-menu-head a").addEventListener("click", (e)=>{
        e.preventDefault();
    });
    // mobile hamburger menu button
    document.querySelector(".mobile_menu_button_two").addEventListener("click", (e)=>{
        const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
        const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
        if (mobile_menu) {
            mobile_menu.classList.toggle("active");
            mobile_menu_close.classList.toggle("active");
        }
    });
    // close mobile menu button
    document.querySelector(".closemobile__inner").addEventListener("click", (e)=>{
        const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
        const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
        if (mobile_menu) {
            mobile_menu.classList.toggle("active");
            mobile_menu_close.classList.toggle("active");
        }
    });
    // close main menu outside of menu
    window.addEventListener("click", function(e) {
        if (!document.getElementById("main_menu").contains(e.target) && !document.getElementById("hamburgerdsktp").contains(e.target)) {
            if (document.getElementById("main_menu").classList.contains("active")) document.getElementById("main_menu").classList.remove("active");
        }
        if (!document.getElementById("mobile_menu").contains(e.target) && !document.getElementById("hamburgermob").contains(e.target)) {
            const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
            const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
            if (mobile_menu) {
                mobile_menu.classList.remove("active");
                mobile_menu_close.classList.remove("active");
            }
        }
    });
    //header banner
    // const bannerwrap = document.querySelector(".bannerouterwrap");
    // var ctaBannerClick = document.querySelectorAll('.ctabarlink');
    // let initview = Cookies.get('initview');
    // let mobileviewport = window.innerWidth < 768;
    // const closeBtn = document.querySelector(".bannerclosebtn");
    // if (bannerwrap && !initview) {
    //     Cookies.set('initview', 'true', { expires: 1 }); // Set cookie to expire in 1 day
    //     setTimeout(showBanner, 1000);
    //     setTimeout(hideBanner, 9000);
    // }
    // if (bannerwrap && !mobileviewport) {
    //     // Add hover event listeners to the banner itself
    //     bannerwrap.addEventListener('mouseenter', showBanner);
    //     bannerwrap.addEventListener('mouseleave', hideBanner);
    //     closeBtn.addEventListener('click', hideBanner);
    // }
    // if (closeBtn) {
    //     closeBtn.addEventListener('click', hideBanner);
    // }
    // // Add hover event listeners to ctaBannerClick elements
    // // ctaBannerClick.forEach(element => {
    // //     element.addEventListener('mouseenter', showBanner);
    // //     element.addEventListener('mouseleave', hideBanner);
    // // });
    // // Add click event listeners to ctaBannerClick elements
    // ctaBannerClick.forEach(element => {
    //     element.addEventListener('click', toggleBanner);
    // });
    // function toggleBanner() {
    //     bannerwrap.classList.toggle("open");
    // }
    // function showBanner() {
    //     bannerwrap.classList.add("open");
    // }
    // function hideBanner() {
    //     bannerwrap.classList.remove("open");
    // }
    // // trustslider
    const trustslider = document.getElementsByClassName("trustslider")[0];
    console.log("here");
    if (trustslider) {
        (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set("initview", true);
        var trustsplide = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(".trustslider", {
            type: "loop",
            perPage: 3,
            perMove: 1,
            arrow: true,
            gap: 20,
            pagination: false,
            arrows: true,
            autoplay: false,
            interval: 3000,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: "280px"
                }
            }
        });
        trustsplide.mount();
    //  Cookies.set('trustvisited', true);
    }
    const initSliderPos = 95;
    var rangeinput = document.getElementById("slider");
    let initrange = 0;
    if (rangeinput) {
        rangeinput.value = initSliderPos;
        // 938w x 744h  
        const beforeaftermob = document.getElementsByClassName("beforeaftermob")[0];
        const beforeafterimgbk = document.getElementsByClassName("background-img")[0];
        const beforeafterimgfore = document.getElementsByClassName("foreground-img")[0];
        resizeMobBeforeAfter();
        window.addEventListener("resize", resizeMobBeforeAfter);
        jQuery("#slider").on("input change", (e)=>{
            const sliderPos = e.target.value;
            // Update the width of the foreground image
            jQuery(".foreground-img").css("width", `${sliderPos}%`);
            jQuery(".forecallouts").css("width", `${sliderPos}%`);
            // Update the position of the slider button
            jQuery(".slider-button").css("left", `calc(${sliderPos}% - 17px)`);
        // if (sliderPos < 50) {
        //     if (initrange == 0) {
        //         initrange = 1
        //         finishMobBeforeAfter();
        //     }
        // }
        });
        function resizeMobBeforeAfter() {
            let winWidth = window.innerWidth;
            let divimgbkWidth = winWidth / 938;
            let divimgbkHeight = divimgbkWidth * 744;
            beforeaftermob.style.height = `${divimgbkHeight}px`;
            beforeafterimgbk.style.height = `${divimgbkHeight}px`;
            beforeafterimgfore.style.height = `${divimgbkHeight}px`;
        }
    }
    // Desktop callouts
    var homeBeforeAfter = document.querySelectorAll(".homebeforeafter");
    // If homebeforeafter exists
    if (homeBeforeAfter.length > 0) {
        var callouts = document.querySelectorAll(".calloutcirc");
        callouts.forEach((el)=>el.addEventListener("click", (event)=>{
                const intPairs = {
                    dskcirc1: "dskcirc8",
                    dskcirc2: "dskcirc9",
                    dskcirc3: "dskcirc10",
                    dskcirc4: "dskcirc11",
                    dskcirc5: "dskcirc12",
                    dskcirc6: "dskcirc13",
                    dskcirc7: "dskcirc14",
                    dskcirc8: "dskcirc1",
                    dskcirc9: "dskcirc2",
                    dskcirc10: "dskcirc3",
                    dskcirc11: "dskcirc4",
                    dskcirc12: "dskcirc5",
                    dskcirc13: "dskcirc6",
                    dskcirc14: "dskcirc7"
                };
                let idnum = event.currentTarget.id;
                let clickedEl = document.getElementById(idnum);
                let pairedEl = document.getElementById(intPairs[idnum]);
                clickedEl.classList.toggle("active");
                pairedEl.classList.toggle("active");
            }));
        const initialDelay = 0.3;
        const delay = 1;
        let leftinterval;
        let rightinterval;
        let leftcloseinterval;
        let rightcloseinterval;
        let leftindx = 0;
        let rightindx = 7;
        let lefthideindx = 0;
        let righthideindx = 7;
        const classnames = [
            "one",
            "two",
            "three",
            "four",
            "five",
            "six",
            "seven",
            "eight",
            "nine",
            "ten",
            "eleven",
            "twelve",
            "thirteen",
            "fourteen"
        ];
        // initial show
        setTimeout(()=>{
            leftinterval = setInterval(()=>{
                let calloutel = document.getElementsByClassName(classnames[leftindx])[0];
                calloutel.classList.toggle("active");
                leftindx++;
                if (leftindx >= 7) clearInterval(leftinterval);
            }, delay * 500);
        }, initialDelay * 500);
        setTimeout(()=>{
            rightinterval = setInterval(()=>{
                let calloutel = document.getElementsByClassName(classnames[rightindx])[0];
                calloutel.classList.toggle("active");
                rightindx++;
                if (rightindx >= 14) clearInterval(rightinterval);
            }, delay * 500);
        }, initialDelay * 500);
        // initial hide
        setTimeout(()=>{
            leftcloseinterval = setInterval(()=>{
                let calloutel = document.getElementsByClassName(classnames[lefthideindx])[0];
                calloutel.classList.remove("active");
                lefthideindx++;
                if (lefthideindx >= 7) clearInterval(leftcloseinterval);
            }, 100);
        }, 10000);
        setTimeout(()=>{
            rightcloseinterval = setInterval(()=>{
                let calloutel = document.getElementsByClassName(classnames[righthideindx])[0];
                calloutel.classList.remove("active");
                righthideindx++;
                if (righthideindx >= 14) clearInterval(rightcloseinterval);
            }, 100);
        }, 10000);
        //  setTimeout(() => {
        //     let scheduleconsul = document.getElementsByClassName('scheduleconsul')[0];
        //    scheduleconsul.classList.add("active");
        // }, 11000)
        // Mobile callouts
        var callouts = document.querySelectorAll(".calloutcircmob");
        callouts.forEach((el)=>el.addEventListener("click", (event)=>{
                const hasClass = event.target.classList.contains("calloutcircmob");
                if (hasClass) event.target.classList.toggle("active");
                else event.target.parentElement.classList.toggle("active");
            }));
        // let mobinterval
        // let mobintervaltwo
        // let mobindx = 0
        // let mobindxtwo = 0
        // const mobclassnames = ['mobone', 'mobtwo', 'mobthree', 'mobfour', 'mobfive', 'mobsix', 'mobseven']
        // const mobclassnamestwo = ['mobeight', 'mobnine', 'mobten', 'mobeleven', 'mobtwelve', 'mobthirteen', 'mobfourteen']
        // // Left side callouts
        // setTimeout(() => {
        //     // call your func here
        //     mobinterval = setInterval(() => {
        //         let mobcalloutel = document.getElementsByClassName(mobclassnames[mobindx])[0];
        //         mobcalloutel.classList.toggle("active");
        //         if (mobindx >= 6)
        //             clearInterval(mobinterval);
        //         mobindx++
        //     }, delay * 1000)
        // }, initialDelay * 1000)
        // // Right side callouts after swipe
        // function finishMobBeforeAfter() {
        //     setTimeout(() => {
        //         // call your func here
        //         mobintervaltwo = setInterval(() => {
        //             let mobcallouteltwo = document.getElementsByClassName(mobclassnamestwo[mobindxtwo])[0];
        //             mobcallouteltwo.classList.toggle("active");
        //             mobindxtwo++
        //             if (mobindxtwo >= 7)
        //                 clearInterval(mobintervaltwo);
        //         }, delay * 1000)
        //     }, initialDelay * 200)
        // }
        // Home hero before after mobile
        var btnafter = document.querySelectorAll(".btnafter");
        var btnbefore = document.querySelectorAll(".btnbefore");
        var mobhomesplideel = document.querySelectorAll(".mobhomesplide");
        if (mobhomesplideel.length > 0) {
            var mobhomesplide = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(".mobhomesplide", {
                perPage: 1,
                perMove: 1,
                type: "slide",
                // classes: {
                //     arrows: 'splide__arrows homeloc-arrows',
                //     arrow : 'splide__arrow homeloc-arrow',
                //     prev  : 'splide__arrow--prev homeloc-prev',
                //     next  : 'splide__arrow--next homeloc-next',
                // },
                pagination: false,
                arrows: false
            });
            mobhomesplide.on("move", function(newIndex, oldIndex, destIndex) {
                console.log(destIndex);
            });
            mobhomesplide.mount();
            btnafter.forEach((el)=>el.addEventListener("click", (event)=>{
                    event.preventDefault();
                    mobhomesplide.go(1);
                }));
            btnbefore.forEach((el)=>el.addEventListener("click", (event)=>{
                    event.preventDefault();
                    mobhomesplide.go(0);
                }));
        }
    }
    jQuery(".leadblue .frm_button_submit").html(window.submitOneText);
    jQuery(".factsmythsright .frm_button_submit").html(window.submitTwoText);
    jQuery(".factsmyths .frm_button_submit").html(window.submitText).addClass("blueback");
    jQuery(".factsmyths .frm_button_submit").parent().addClass("center");
    var homethreegrid = document.querySelectorAll(".homethreegrid");
    if (homethreegrid.length > 0) {
        let testHomegridPos = isScrolledIntoView(homethreegrid);
        let initialHomeGridDelay = 300;
        const stepdelay = 0.3;
        let homeGridinterval;
        let indx = 1;
        if (testHomegridPos == true) setTimeout(()=>{
            // call your func here
            homeGridinterval = setInterval(()=>{
                let calloutel = document.getElementById("homegrid" + indx);
                calloutel.querySelector(".vc_column-inner").classList.add("active");
                indx++;
                if (indx >= 4) clearInterval(homeGridinterval);
            }, stepdelay * 1000);
        }, initialHomeGridDelay);
        else {
            let initScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchHomegridPos = isScrolledIntoView(homethreegrid);
                if (watchHomegridPos == true && initScroll == false) {
                    initScroll = true;
                    initialHomeGridDelay = 0;
                    setTimeout(()=>{
                        // call your func here
                        homeGridinterval = setInterval(()=>{
                            let calloutel = document.getElementById("homegrid" + indx);
                            calloutel.querySelector(".vc_column-inner").classList.add("active");
                            indx++;
                            if (indx >= 4) clearInterval(homeGridinterval);
                        }, stepdelay * 1000);
                    }, initialHomeGridDelay);
                }
            }, false);
        }
        let homegrid1 = document.getElementById("homegrid1");
        homegrid1.addEventListener("click", function(e) {
            e.preventDefault();
            window.location.href = "/solutions-for-denture-wearers/";
        });
        let homegrid2 = document.getElementById("homegrid2");
        homegrid2.addEventListener("click", function(e) {
            e.preventDefault();
            window.location.href = "/solutions-for-missing-and-failing-teeth/";
        });
        let homegrid3 = document.getElementById("homegrid3");
        homegrid3.addEventListener("click", function(e) {
            e.preventDefault();
            window.location.href = "/zygomatic-implants/";
        });
    }
    // home mobile before after
    var homeBeforeAfterMob = document.querySelectorAll(".beforeaftermob");
    if (homeBeforeAfterMob.length > 0) {
        let homemoblfthead = document.getElementById("homemoblfthead");
        let homemoblftimg = document.getElementById("homemoblftimg");
        let homemobrthead = document.getElementById("homemobrthead");
        let homemobrtimg = document.getElementById("homemobrtimg");
        let homeBeforeAfterMobPos = isScrolledIntoView(homeBeforeAfterMob);
        let curheroimg = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("heromob");
        if (curheroimg == undefined) (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set("heromob", 1);
        else {
            if (curheroimg == 1) curheroimg = 2;
            else if (curheroimg == 2) curheroimg = 1;
            (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set("heromob", curheroimg.toString());
        }
        if (curheroimg == 1) {
            homemoblftimg.src = "/wp-content/themes/bridge-child/resources/images/homemob_before_mark.png";
            homemobrtimg.src = "/wp-content/themes/bridge-child/resources/images/homemob_after_mark.png";
        } else if (curheroimg == 2) {
            homemoblftimg.src = "/wp-content/themes/bridge-child/resources/images/homemob_before_marissa.png";
            homemobrtimg.src = "/wp-content/themes/bridge-child/resources/images/homemob_after_marissa.png";
        }
        if (homeBeforeAfterMobPos == true) runBeforeAfterMob();
        else {
            let initHomeBeforeAfterMobScroll = false;
            window.addEventListener("scroll", function(e) {
                let homeBeforeAfterMobScrollPos = isScrolledIntoView(homeBeforeAfterMob);
                if (homeBeforeAfterMobScrollPos == true && initHomeBeforeAfterMobScroll == false) {
                    initHomeBeforeAfterMobScroll = true;
                    runBeforeAfterMob();
                }
            }, false);
        }
        function runBeforeAfterMob() {
            let initialHomeBeforeAfterMobDelay = 0;
            const stepdelay = 0.3;
            let homeBeforeAfterMobintervalLeft;
            let homeBeforeAfterMobintervalRight;
            setTimeout(()=>{
                // call your func here
                homeBeforeAfterMobintervalLeft = setInterval(()=>{
                    homemoblfthead.classList.add("active");
                    homemoblftimg.classList.add("active");
                    clearInterval(homeBeforeAfterMobintervalLeft);
                }, 200);
            }, initialHomeBeforeAfterMobDelay);
            setTimeout(()=>{
                // call your func here
                homeBeforeAfterMobintervalRight = setInterval(()=>{
                    homemobrthead.classList.add("active");
                    homemobrtimg.classList.add("active");
                    clearInterval(homeBeforeAfterMobintervalRight);
                }, 600);
            }, initialHomeBeforeAfterMobDelay);
        }
    }
    // home benefits circle grid
    var benefitsgrid = document.querySelectorAll(".benefitsgrid");
    if (benefitsgrid.length > 0) {
        let benfitsHomeGridPos = isScrolledIntoView(benefitsgrid);
        if (benfitsHomeGridPos == true) runHomeBenefitsGrid();
        else {
            let initHomeBenefitsScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchHomeBenefitsGridPos = isScrolledIntoView(benefitsgrid);
                if (watchHomeBenefitsGridPos == true && initHomeBenefitsScroll == false) {
                    initHomeBenefitsScroll = true;
                    runHomeBenefitsGrid();
                }
            }, false);
        }
    }
    function runHomeBenefitsGrid() {
        let initialBenefitsGridDelay = 0;
        const gridstepdelay = 0.5;
        let homeBenefitsGridinterval;
        let benecircindx = 1;
        let homeBenefitsIconinterval;
        let beneiconindx = 1;
        let homeBenefitsTextinterval;
        let benetextindx = 1;
        setTimeout(()=>{
            // call your func here
            homeBenefitsGridinterval = setInterval(()=>{
                let benefitscircel = document.getElementById("iconcirc" + benecircindx);
                benefitscircel.classList.add("active");
                benecircindx++;
                if (benecircindx >= 7) clearInterval(homeBenefitsGridinterval);
            }, gridstepdelay * 1000);
        }, initialBenefitsGridDelay);
        setTimeout(()=>{
            // call your func here
            homeBenefitsIconinterval = setInterval(()=>{
                let benefitsiconel = document.getElementById("icon" + beneiconindx);
                benefitsiconel.classList.add("active");
                beneiconindx++;
                if (beneiconindx >= 7) clearInterval(homeBenefitsIconinterval);
            }, gridstepdelay * 1000);
        }, initialBenefitsGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            homeBenefitsTextinterval = setInterval(()=>{
                let benefitstextel = document.getElementById("icontext" + benetextindx);
                benefitstextel.classList.add("active");
                benetextindx++;
                if (benetextindx >= 7) clearInterval(homeBenefitsTextinterval);
            }, gridstepdelay * 1000);
        }, initialBenefitsGridDelay + 700);
    }
    // costscircle grid
    var costsgrid = document.querySelectorAll(".costsgrid");
    if (costsgrid.length > 0) {
        let costsHomeGridPos = isScrolledIntoView(costsgrid);
        if (costsHomeGridPos == true) runHomeCostsGrid();
        else {
            let initCostsScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchCostsGridPos = isScrolledIntoView(costsgrid);
                if (watchCostsGridPos == true && initCostsScroll == false) {
                    initCostsScroll = true;
                    runHomeCostsGrid();
                }
            }, false);
        }
    }
    function runHomeCostsGrid() {
        let initialCostsGridDelay = 0;
        const costsgridstepdelay = 0.5;
        let costsGridinterval;
        let costscircindx = 1;
        let costsIconinterval;
        let costsiconindx = 1;
        let costsTextinterval;
        let coststextindx = 1;
        setTimeout(()=>{
            // call your func here
            costsGridinterval = setInterval(()=>{
                let costscircel = document.getElementById("iconcirc" + costscircindx);
                costscircel.classList.add("active");
                costscircindx++;
                if (costscircindx >= 5) clearInterval(costsGridinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay);
        setTimeout(()=>{
            // call your func here
            costsIconinterval = setInterval(()=>{
                let costsiconel = document.getElementById("icon" + costsiconindx);
                costsiconel.classList.add("active");
                costsiconindx++;
                if (costsiconindx >= 7) clearInterval(costsIconinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            costsTextinterval = setInterval(()=>{
                let coststextel = document.getElementById("icontext" + coststextindx);
                coststextel.classList.add("active");
                coststextindx++;
                if (coststextindx >= 7) clearInterval(costsTextinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay + 700);
    }
    // specialists grid
    var specialistsgrid = document.querySelectorAll(".specialistsgrid");
    if (specialistsgrid.length > 0) {
        let costsSpecialistsGridPos = isScrolledIntoView(specialistsgrid);
        if (costsSpecialistsGridPos == true) runHomeSpecialistsGrid();
        else {
            let initSpecialistsScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchSpecialistsGridPos = isScrolledIntoView(specialistsgrid);
                if (watchSpecialistsGridPos == true && initSpecialistsScroll == false) {
                    initSpecialistsScroll = true;
                    runHomeSpecialistsGrid();
                }
            }, false);
        }
    }
    function runHomeSpecialistsGrid() {
        let initialSpecialistsGridDelay = 0;
        const specialistsgridstepdelay = 0.5;
        let specialistsGridinterval;
        let specialistscircindx = 1;
        let specialistsIconinterval;
        let specialistsiconindx = 1;
        let specialistsTextinterval;
        let specialiststextindx = 1;
        setTimeout(()=>{
            // call your func here
            specialistsGridinterval = setInterval(()=>{
                let specialistscircel = document.getElementById("iconcirc" + specialistscircindx);
                specialistscircel.classList.add("active");
                specialistscircindx++;
                if (specialistscircindx >= 6) clearInterval(specialistsGridinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay);
        setTimeout(()=>{
            // call your func here
            specialistsIconinterval = setInterval(()=>{
                let specialistsiconel = document.getElementById("icon" + specialistsiconindx);
                specialistsiconel.classList.add("active");
                specialistsiconindx++;
                if (specialistsiconindx >= 6) clearInterval(specialistsIconinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            specialistsTextinterval = setInterval(()=>{
                let specialiststextel = document.getElementById("icontext" + specialiststextindx);
                specialiststextel.classList.add("active");
                specialiststextindx++;
                if (specialiststextindx >= 6) clearInterval(specialistsTextinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay + 700);
    }
    // comparison grid
    var comparisongrid = document.querySelectorAll(".comparisongrid");
    if (comparisongrid.length > 0) {
        let comparisonGridPos = isScrolledIntoView(comparisongrid);
        if (comparisonGridPos == true) runComparisonGrid();
        else {
            let initComparisonScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchComparisonGridPos = isScrolledIntoView(comparisongrid);
                if (watchComparisonGridPos == true && initComparisonScroll == false) {
                    initComparisonScroll = true;
                    runComparisonGrid();
                }
            }, false);
        }
    }
    function runComparisonGrid() {
        let initialComparisonGridDelay = 0;
        const comparisongridstepdelay = 0.5;
        let comparisonGridinterval;
        let comparisoncircindx = 1;
        let comparisonIconinterval;
        let comparisoniconindx = 1;
        let comparisonTextinterval;
        let comparisontextindx = 1;
        setTimeout(()=>{
            // call your func here
            comparisonGridinterval = setInterval(()=>{
                let comparisoncircel = document.getElementById("iconcirc" + comparisoncircindx);
                comparisoncircel.classList.add("active");
                comparisoncircindx++;
                if (comparisoncircindx >= 6) clearInterval(comparisonGridinterval);
            }, comparisongridstepdelay * 1000);
        }, initialComparisonGridDelay);
        setTimeout(()=>{
            // call your func here
            comparisonIconinterval = setInterval(()=>{
                let comparisoniconel = document.getElementById("icon" + comparisoniconindx);
                comparisoniconel.classList.add("active");
                comparisoniconindx++;
                if (comparisoniconindx >= 6) clearInterval(comparisonIconinterval);
            }, comparisongridstepdelay * 1000);
        }, initialComparisonGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            comparisonTextinterval = setInterval(()=>{
                let comparisontextel = document.getElementById("icontext" + comparisontextindx);
                comparisontextel.classList.add("active");
                comparisontextindx++;
                if (comparisontextindx >= 6) clearInterval(comparisonTextinterval);
            }, comparisongridstepdelay * 1000);
        }, initialComparisonGridDelay + 700);
    }
    // costscircle grid
    var costsgrid = document.querySelectorAll(".costsgrid");
    if (costsgrid.length > 0) {
        let costsHomeGridPos = isScrolledIntoView(costsgrid);
        if (costsHomeGridPos == true) runHomeCostsGrid();
        else {
            let initCostsScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchCostsGridPos = isScrolledIntoView(costsgrid);
                if (watchCostsGridPos == true && initCostsScroll == false) {
                    initCostsScroll = true;
                    runHomeCostsGrid();
                }
            }, false);
        }
    }
    function runHomeCostsGrid() {
        let initialCostsGridDelay = 0;
        const costsgridstepdelay = 0.5;
        let costsGridinterval;
        let costscircindx = 1;
        let costsIconinterval;
        let costsiconindx = 1;
        let costsTextinterval;
        let coststextindx = 1;
        setTimeout(()=>{
            // call your func here
            costsGridinterval = setInterval(()=>{
                let costscircel = document.getElementById("iconcirc" + costscircindx);
                costscircel.classList.add("active");
                costscircindx++;
                if (costscircindx >= 5) clearInterval(costsGridinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay);
        setTimeout(()=>{
            // call your func here
            costsIconinterval = setInterval(()=>{
                let costsiconel = document.getElementById("icon" + costsiconindx);
                costsiconel.classList.add("active");
                costsiconindx++;
                if (costsiconindx >= 5) clearInterval(costsIconinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            costsTextinterval = setInterval(()=>{
                let coststextel = document.getElementById("icontext" + coststextindx);
                coststextel.classList.add("active");
                coststextindx++;
                if (coststextindx >= 5) clearInterval(costsTextinterval);
            }, costsgridstepdelay * 1000);
        }, initialCostsGridDelay + 700);
    }
    // specialists grid
    var specialistsgrid = document.querySelectorAll(".specialistsgrid");
    if (specialistsgrid.length > 0) {
        let costsSpecialistsGridPos = isScrolledIntoView(specialistsgrid);
        if (costsSpecialistsGridPos == true) runHomeSpecialistsGrid();
        else {
            let initSpecialistsScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchSpecialistsGridPos = isScrolledIntoView(specialistsgrid);
                if (watchSpecialistsGridPos == true && initSpecialistsScroll == false) {
                    initSpecialistsScroll = true;
                    runHomeSpecialistsGrid();
                }
            }, false);
        }
    }
    function runHomeSpecialistsGrid() {
        let initialSpecialistsGridDelay = 0;
        const specialistsgridstepdelay = 0.5;
        let specialistsGridinterval;
        let specialistscircindx = 1;
        let specialistsIconinterval;
        let specialistsiconindx = 1;
        let specialistsTextinterval;
        let specialiststextindx = 1;
        setTimeout(()=>{
            // call your func here
            specialistsGridinterval = setInterval(()=>{
                let specialistscircel = document.getElementById("iconcirc" + specialistscircindx);
                specialistscircel.classList.add("active");
                specialistscircindx++;
                if (specialistscircindx >= 6) clearInterval(specialistsGridinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay);
        setTimeout(()=>{
            // call your func here
            specialistsIconinterval = setInterval(()=>{
                let specialistsiconel = document.getElementById("icon" + specialistsiconindx);
                specialistsiconel.classList.add("active");
                specialistsiconindx++;
                if (specialistsiconindx >= 6) clearInterval(specialistsIconinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            specialistsTextinterval = setInterval(()=>{
                let specialiststextel = document.getElementById("icontext" + specialiststextindx);
                specialiststextel.classList.add("active");
                specialiststextindx++;
                if (specialiststextindx >= 6) clearInterval(specialistsTextinterval);
            }, specialistsgridstepdelay * 1000);
        }, initialSpecialistsGridDelay + 700);
    }
    // value grid
    var valuegrid = document.querySelectorAll(".valuegrid");
    if (valuegrid.length > 0) {
        let valueGridPos = isScrolledIntoView(valuegrid);
        if (valueGridPos == true) runValueGrid();
        else {
            let initValueScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchValueGridPos = isScrolledIntoView(valuegrid);
                if (watchValueGridPos == true && initValueScroll == false) {
                    initValueScroll = true;
                    runValueGrid();
                }
            }, false);
        }
    }
    function runValueGrid() {
        let initialValueGridDelay = 0;
        const valuegridstepdelay = 0.5;
        let valueGridinterval;
        let valuecircindx = 1;
        let valueIconinterval;
        let valueiconindx = 1;
        let valueTextinterval;
        let valuetextindx = 1;
        setTimeout(()=>{
            // call your func here
            valueGridinterval = setInterval(()=>{
                let valuecircel = document.getElementById("iconcirc" + valuecircindx);
                valuecircel.classList.add("active");
                valuecircindx++;
                if (valuecircindx >= 6) clearInterval(valueGridinterval);
            }, valuegridstepdelay * 1000);
        }, initialValueGridDelay);
        setTimeout(()=>{
            // call your func here
            valueIconinterval = setInterval(()=>{
                let valueiconel = document.getElementById("icon" + valueiconindx);
                valueiconel.classList.add("active");
                valueiconindx++;
                if (valueiconindx >= 6) clearInterval(valueIconinterval);
            }, valuegridstepdelay * 1000);
        }, initialValueGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            valueTextinterval = setInterval(()=>{
                let valuetextel = document.getElementById("icontext" + valuetextindx);
                valuetextel.classList.add("active");
                valuetextindx++;
                if (valuetextindx >= 6) clearInterval(valueTextinterval);
            }, valuegridstepdelay * 1000);
        }, initialValueGridDelay + 700);
    }
    // lab grid
    var labgrid = document.querySelectorAll(".labgrid");
    if (labgrid.length > 0) {
        let labGridPos = isScrolledIntoView(labgrid);
        if (labGridPos == true) runLabGrid();
        else {
            let initLabScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchLabGridPos = isScrolledIntoView(labgrid);
                if (watchLabGridPos == true && initLabScroll == false) {
                    initLabScroll = true;
                    runLabGrid();
                }
            }, false);
        }
    }
    function runLabGrid() {
        let initialLabGridDelay = 0;
        const labgridstepdelay = 0.5;
        let labGridinterval;
        let labcircindx = 1;
        let labIconinterval;
        let labiconindx = 1;
        let labTextinterval;
        let labtextindx = 1;
        setTimeout(()=>{
            // call your func here
            labGridinterval = setInterval(()=>{
                let labcircel = document.getElementById("iconcirc" + labcircindx);
                labcircel.classList.add("active");
                labcircindx++;
                if (labcircindx >= 6) clearInterval(labGridinterval);
            }, labgridstepdelay * 1000);
        }, initialLabGridDelay);
        setTimeout(()=>{
            // call your func here
            labIconinterval = setInterval(()=>{
                let labiconel = document.getElementById("icon" + labiconindx);
                labiconel.classList.add("active");
                labiconindx++;
                if (labiconindx >= 6) clearInterval(labIconinterval);
            }, labgridstepdelay * 1000);
        }, initialLabGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            labTextinterval = setInterval(()=>{
                let labtextel = document.getElementById("icontext" + labtextindx);
                labtextel.classList.add("active");
                labtextindx++;
                if (labtextindx >= 6) clearInterval(labTextinterval);
            }, labgridstepdelay * 1000);
        }, initialLabGridDelay + 700);
    }
    // bone issues grid
    var boneissuesgrid = document.querySelectorAll(".boneissuesgrid");
    if (boneissuesgrid.length > 0) {
        let boneissuesGridPos = isScrolledIntoView(boneissuesgrid);
        if (boneissuesGridPos == true) runBoneIssuesGrid();
        else {
            let initBoneIssuesScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchBoneIssuesGridPos = isElementXPercentInViewport(boneissuesgrid);
                if (watchBoneIssuesGridPos == true && initBoneIssuesScroll == false) {
                    initBoneIssuesScroll = true;
                    runBoneIssuesGrid();
                }
            }, false);
        }
    }
    function runBoneIssuesGrid() {
        let initialBoneIssuesGridDelay = 0;
        const boneissuesgridstepdelay = 0.5;
        let boneIssuesGridinterval;
        let boneIssuescircindx = 1;
        let boneIssuesIconinterval;
        let boneIssuesiconindx = 1;
        let boneIssuesTextinterval;
        let boneIssuestextindx = 1;
        let boneIssuesHeadinterval;
        let boneIssuesheadindx = 1;
        setTimeout(()=>{
            // call your func here
            boneIssuesGridinterval = setInterval(()=>{
                let boneissuescircel = document.getElementById("iconcirc" + boneIssuescircindx);
                boneissuescircel.classList.add("active");
                boneIssuescircindx++;
                if (boneIssuescircindx >= 4) clearInterval(boneIssuesGridinterval);
            }, boneissuesgridstepdelay * 1000);
        }, initialBoneIssuesGridDelay);
        setTimeout(()=>{
            // call your func here
            boneIssuesIconinterval = setInterval(()=>{
                let boneissuesiconel = document.getElementById("icon" + boneIssuesiconindx);
                boneissuesiconel.classList.add("active");
                boneIssuesiconindx++;
                if (boneIssuesiconindx >= 4) clearInterval(boneIssuesIconinterval);
            }, boneissuesgridstepdelay * 1000);
        }, initialBoneIssuesGridDelay + 400);
        setTimeout(()=>{
            // call your func here
            boneIssuesTextinterval = setInterval(()=>{
                let boneissuestextel = document.getElementById("icontext" + boneIssuestextindx);
                boneissuestextel.classList.add("active");
                boneIssuestextindx++;
                if (boneIssuestextindx >= 4) clearInterval(boneIssuesTextinterval);
            }, boneissuesgridstepdelay * 1000);
        }, initialBoneIssuesGridDelay + 700);
        setTimeout(()=>{
            // call your func here
            boneIssuesHeadinterval = setInterval(()=>{
                let boneissuesheadel = document.getElementById("head" + boneIssuesheadindx);
                boneissuesheadel.classList.add("active");
                boneIssuesheadindx++;
                if (boneIssuesheadindx >= 4) clearInterval(boneIssuesHeadinterval);
            }, boneissuesgridstepdelay * 1000);
        }, initialBoneIssuesGridDelay + 700);
    }
    // consul grid
    var consulgrid = document.querySelectorAll(".consulgrid");
    if (consulgrid.length > 0) {
        let consulGridPos = isScrolledIntoView(consulgrid);
        if (consulGridPos == true) runConsulGrid();
        else {
            let initConsulScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchConsulGridPos = isScrolledIntoView(consulgrid);
                if (watchConsulGridPos == true && initConsulScroll == false) {
                    initConsulScroll = true;
                    runConsulGrid();
                }
            }, false);
        }
    }
    function runConsulGrid() {
        let initialConsulGridDelay = 0;
        const consulgridstepdelay = 0.5;
        let consulGridinterval;
        let consulindx = 1;
        setTimeout(()=>{
            // call your func here
            consulGridinterval = setInterval(()=>{
                let consulel = document.getElementById("consulicon" + consulindx);
                consulel.classList.add("active");
                consulel.addEventListener("mouseover", function(e) {
                    e.target.parentElement.classList.remove("active");
                });
                consulel.addEventListener("mouseout", function(e) {
                    e.target.parentElement.classList.add("active");
                });
                consulel.addEventListener("click", function(e) {
                    e.preventDefault();
                });
                consulindx++;
                if (consulindx >= 5) clearInterval(consulGridinterval);
            }, consulgridstepdelay * 1000);
        }, initialConsulGridDelay);
    }
    // daysaway grid
    var daysaway = document.querySelectorAll(".daysaway");
    if (daysaway.length > 0) {
        let daysAwayPos = isScrolledIntoView(daysaway);
        if (daysAwayPos == true) runDaysAway();
        else {
            let initDaysAwayScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchDaysAwayPos = isScrolledIntoView(daysaway);
                if (watchDaysAwayPos == true && initDaysAwayScroll == false) {
                    initDaysAwayScroll = true;
                    runDaysAway();
                }
            }, false);
        }
        function runDaysAway() {
            let initialDaysAwayDelay = 0;
            const daysawaystepdelay = 0.5;
            let daysAwayinterval;
            let daysawayindx = 1;
            setTimeout(()=>{
                // call your func here
                daysAwayinterval = setInterval(()=>{
                    let daysawayel = document.getElementById("daysaway" + daysawayindx);
                    daysawayel.classList.add("active");
                    daysawayindx++;
                    if (daysawayindx >= 9) clearInterval(daysAwayinterval);
                }, daysawaystepdelay * 1000);
            }, initialDaysAwayDelay);
        }
    }
    var daysawaymob = document.querySelectorAll(".daysawaymob");
    if (daysawaymob.length > 0) {
        let daysAwayMobPos = isScrolledIntoView(daysawaymob);
        if (daysAwayMobPos == true) runDaysAwayMob();
        else {
            let initDaysAwayMobScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchDaysAwayMobPos = isScrolledMobIntoView(daysawaymob);
                if (watchDaysAwayMobPos == true && initDaysAwayMobScroll == false) {
                    initDaysAwayMobScroll = true;
                    runDaysAwayMob();
                }
            }, false);
        }
        function runDaysAwayMob() {
            let initialDaysAwayMobDelay = 0;
            const daysawaymobstepdelay = 0.5;
            let daysAwayMobinterval;
            let daysawaymobindx = 1;
            setTimeout(()=>{
                // call your func here
                daysAwayMobinterval = setInterval(()=>{
                    let daysawaymobel = document.getElementById("daysawaymob" + daysawaymobindx);
                    daysawaymobel.classList.add("active");
                    daysawaymobindx++;
                    if (daysawaymobindx >= 9) clearInterval(daysAwayMobinterval);
                }, daysawaymobstepdelay * 1000);
            }, initialDaysAwayMobDelay);
        }
    }
    // full arch grid
    var fullflow = document.querySelectorAll(".fullarchworkflowinner");
    if (fullflow.length > 0) {
        let fullarchworkPos = isScrolledIntoView(fullflow);
        if (fullarchworkPos == true) runFullArchWorkFlow();
        else {
            let initFullArchWorkScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchFullArchWorkPos = isElementXPercentInViewport(fullflow);
                if (watchFullArchWorkPos == true && initFullArchWorkScroll == false) {
                    initFullArchWorkScroll = true;
                    runFullArchWorkFlow();
                }
            }, false);
        }
        function runFullArchWorkFlow() {
            let initialFullArchWorkDelay = 0;
            const fullarchworkstepdelay = 0.5;
            let fullArchWorkInterval;
            let fullarchworkindx = 1;
            let fullarchworktrack = document.getElementById("flowtrack");
            fullarchworktrack.classList.add("active");
            setTimeout(()=>{
                // call your func here
                fullArchWorkInterval = setInterval(()=>{
                    let fullarchworkel = document.getElementById("step" + fullarchworkindx);
                    fullarchworkel.classList.add("active");
                    fullarchworkindx++;
                    if (fullarchworkindx >= 7) clearInterval(fullArchWorkInterval);
                }, fullarchworkstepdelay * 1000);
            }, initialFullArchWorkDelay);
        }
    }
    // health risks chart
    var healthrisks = document.querySelectorAll(".healthrisksgraph");
    if (healthrisks.length > 0) {
        let healthrisksPos = isScrolledIntoView(healthrisks);
        if (healthrisksPos == true) runHealthRisks();
        else {
            let initHealthRisksScroll = false;
            window.addEventListener("scroll", function(e) {
                let watchHealthRisksPos = isElementXPercentInViewport(healthrisks);
                if (watchHealthRisksPos == true && initHealthRisksScroll == false) {
                    initHealthRisksScroll = true;
                    runHealthRisks();
                }
            }, false);
        }
        function runHealthRisks() {
            let initialHealthRisksDelay = 0;
            const fullhealthrisksstepdelay = 0.4;
            let healthRisksInterval;
            let healthRisksindx = 1;
            console.log("run health risks chart");
            setTimeout(()=>{
                // call your func here
                healthRisksInterval = setInterval(()=>{
                    let healthriskel = document.getElementById("bartop-" + healthRisksindx);
                    healthriskel.classList.add("active");
                    let healthriskelbot = document.getElementById("barbottom-" + healthRisksindx);
                    healthriskelbot.classList.add("active");
                    if (healthRisksindx <= 3) {
                        let graphbarlabel = document.getElementById("label-" + healthRisksindx);
                        graphbarlabel.classList.add("active");
                    }
                    healthRisksindx++;
                    if (healthRisksindx >= 10) clearInterval(healthRisksInterval);
                }, fullhealthrisksstepdelay * 700);
            }, initialHealthRisksDelay);
        }
    }
    // health source toggle
    var healthsources = document.querySelectorAll(".healthsources");
    if (healthsources.length > 0) {
        var viewsources = document.querySelectorAll(".viewsources");
        var sourcestext = document.querySelectorAll(".sourcestext");
        viewsources.forEach((el)=>el.addEventListener("click", (event)=>{
                event.preventDefault();
                if (sourcestext[0].classList.contains("active")) {
                    sourcestext[0].classList.remove("active");
                    viewsources[0].classList.remove("active");
                } else {
                    sourcestext[0].classList.add("active");
                    viewsources[0].classList.add("active");
                }
            }));
    }
    // bio items
    var biowrap = document.querySelectorAll(".biowrap");
    if (biowrap.length > 0) {
        var morebuttons = document.querySelectorAll(".morebutton");
        morebuttons.forEach((el)=>el.addEventListener("click", (event)=>{
                event.preventDefault();
                event.currentTarget.parentNode.parentNode.classList.toggle("active");
            }));
    }
    // faq items
    var faqsouter = document.querySelectorAll(".faqsouter");
    if (faqsouter.length > 0) {
        var faqs = document.querySelectorAll(".faq");
        faqs.forEach((el)=>el.addEventListener("click", (event)=>{
                event.preventDefault();
                event.currentTarget.classList.toggle("active");
            }));
    }
    // jump links
    if (window.location.href.indexOf("gps-specialist-team/#") > -1) {
        let hash = window.location.hash.substring(1);
        let bioel = document.getElementById(hash);
        let curScroll = document.documentElement.scrollTop;
        let w = window.innerWidth;
        let animheight = 150;
        if (w < 850) animheight = -10;
        bioel.classList.add("active");
        curScroll = curScroll + animheight;
        window.scrollTo({
            top: curScroll,
            behavior: "smooth"
        });
    }
    //survey map
    var surveymapwrap = document.querySelectorAll(".surveymapwrap");
    if (surveymapwrap.length > 0) {
        const viewport = window.innerWidth;
        let coordinates = "/wp-content/themes/bridge-child/scripts/coordinates.json";
        let zoom = 5.65;
        let center = [
            -115.6893562,
            35.35
        ];
        if (viewport < 640) {
            coordinates = "/wp-content/themes/bridge-child/scripts/mob_coordinates.json";
            zoom = 5.3;
            center = [
                -116.6893562,
                35.30
            ];
        }
        mapboxgl.accessToken = "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
        const map = new mapboxgl.Map({
            container: "surveymap",
            // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
            style: "mapbox://styles/mapbox/light-v11",
            center: center,
            interactive: false,
            zoom: zoom
        });
        map.on("load", ()=>{
            fetch(coordinates).then((response)=>response.json()).then((data)=>{
                map.addSource("places", {
                    "type": "geojson",
                    "data": data
                });
                map.addLayer({
                    "id": "places",
                    "type": "circle",
                    "source": "places",
                    "paint": {
                        "circle-color": [
                            "get",
                            "color"
                        ],
                        "circle-radius": 4,
                        "circle-stroke-width": 1,
                        "circle-stroke-color": "#ffffff"
                    }
                });
            }).catch((error)=>console.error("Error loading locations:", error));
        });
    }
    // homeLocations map
    var homeLocations = document.querySelectorAll(".homemapcolleft");
    var homelocationinnerwrap = document.querySelectorAll(".homelocationinnerwrap");
    var backtolist = document.querySelectorAll(".backtolist");
    let curLoc = "";
    if (homeLocations.length > 0) {
        mapboxgl.accessToken = "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
        const map = new mapboxgl.Map({
            container: "map",
            // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
            style: "mapbox://styles/mapbox/light-v11",
            center: [
                -117.906454,
                33.654739
            ],
            zoom: 8.8,
            interactive: false
        });
        map.scrollZoom.disable();
        map.on("load", ()=>{
            backtolist.forEach((el)=>el.addEventListener("click", (event)=>{
                    event.preventDefault();
                    homelocationinnerwrap[0].classList.remove("active");
                    map.setPaintProperty("polygon1", "fill-opacity", 0);
                    map.setPaintProperty("polygon2", "fill-opacity", 0);
                    map.setPaintProperty("polygon3", "fill-opacity", 0);
                    map.setPaintProperty("polygon4", "fill-opacity", 0);
                    map.setPaintProperty("polygon5", "fill-opacity", 0);
                    map.setPaintProperty("polygon6", "fill-opacity", 0);
                    map.setPaintProperty("polygon7", "fill-opacity", 0);
                }));
        });
        var homemapinview = document.querySelectorAll(".homemap");
        let homeMapPos = isScrolledIntoView(homemapinview);
        let initHomeMapScroll = false;
        if (homeMapPos == true) ;
        else window.addEventListener("scroll", function(e) {
            let watchHomeMapPos = isScrolledIntoView(homemapinview);
            if (watchHomeMapPos == true && initHomeMapScroll == false) initHomeMapScroll = true;
        }, false);
        function loadHomeMap(map) {
            // Dana Point
            const locOnePointLatLng = [
                -117.7231871,
                33.4943349
            ];
            function locationOne() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker1", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points1", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Dana Point
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locOnePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points1",
                        type: "symbol",
                        source: "points1",
                        layout: {
                            "icon-image": "custom-marker1",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon1", createGeoJSONCircle(locOnePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon1",
                    type: "fill",
                    source: "polygon1",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
                let locone = document.querySelector(".locone");
                setTimeout(function() {
                    locone.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locone.classList.remove("active");
                }, 800);
            }
            // Huntington Beach
            const locTwoPointLatLng = [
                -117.80613095792333,
                33.70670350274985
            ];
            function locationTwo() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker2", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points2", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locTwoPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points2",
                        type: "symbol",
                        source: "points2",
                        layout: {
                            "icon-image": "custom-marker2",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon2", createGeoJSONCircle(locTwoPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon2",
                    type: "fill",
                    source: "polygon2",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0
                    }
                });
                let loctwo = document.querySelector(".loctwo");
                setTimeout(function() {
                    loctwo.classList.add("active");
                }, 200);
                setTimeout(function() {
                    loctwo.classList.remove("active");
                }, 800);
            }
            // Riverside
            const locThreePointLatLng = [
                -117.401028,
                33.9493029
            ];
            function locationThree() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker3", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points3", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locThreePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points3",
                        type: "symbol",
                        source: "points3",
                        layout: {
                            "icon-image": "custom-marker3",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon3", createGeoJSONCircle(locThreePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon3",
                    type: "fill",
                    source: "polygon3",
                    layout: {},
                    paint: {
                        "fill-color": "#a1d9d2",
                        "fill-opacity": 0
                    }
                });
                let locthree = document.querySelector(".locthree");
                setTimeout(function() {
                    locthree.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locthree.classList.remove("active");
                }, 800);
            }
            // Valley
            const locFourPointLatLng = [
                -118.5294178,
                34.2007831
            ];
            function locationFour() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker4", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points4", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFourPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points4",
                        type: "symbol",
                        source: "points4",
                        layout: {
                            "icon-image": "custom-marker4",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon4", createGeoJSONCircle(locFourPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon4",
                    type: "fill",
                    source: "polygon4",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
                let locfour = document.querySelector(".locfour");
                setTimeout(function() {
                    locfour.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locfour.classList.remove("active");
                }, 800);
            }
            // San Gabriel
            const locFivePointLatLng = [
                -117.9261074,
                34.071511
            ];
            function locationFive() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker5", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points5", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFivePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points5",
                        type: "symbol",
                        source: "points5",
                        layout: {
                            "icon-image": "custom-marker5",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon5", createGeoJSONCircle(locFivePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon5",
                    type: "fill",
                    source: "polygon5",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0
                    }
                });
                let locfive = document.querySelector(".locfive");
                setTimeout(function() {
                    locfive.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locfive.classList.remove("active");
                }, 800);
            }
            // Antelope Valley
            const locSixPointLatLng = [
                -118.1426083,
                34.5872707
            ];
            function locationSix() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker6", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points6", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSixPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points6",
                        type: "symbol",
                        source: "points6",
                        layout: {
                            "icon-image": "custom-marker6",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon6", createGeoJSONCircle(locSixPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon6",
                    type: "fill",
                    source: "polygon6",
                    layout: {},
                    paint: {
                        "fill-color": "#a1d9d2",
                        "fill-opacity": 0
                    }
                });
                let locsix = document.querySelector(".locsix");
                setTimeout(function() {
                    locsix.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locsix.classList.remove("active");
                }, 800);
            }
            // Valencia
            const locSevenPointLatLng = [
                -118.5808355,
                34.4068893
            ];
            function locationSeven() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker7", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points7", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Valencia
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSevenPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points7",
                        type: "symbol",
                        source: "points7",
                        layout: {
                            "icon-image": "custom-marker6",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon7", createGeoJSONCircle(locSevenPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon7",
                    type: "fill",
                    source: "polygon7",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
                let locseven = document.querySelector(".locseven");
                setTimeout(function() {
                    locseven.classList.add("active");
                }, 200);
                setTimeout(function() {
                    locseven.classList.remove("active");
                }, 800);
            }
            function placeMarkers() {
                let locinterval;
                let locindx = 1;
                setTimeout(()=>{
                    // call your func here
                    locinterval = setInterval(()=>{
                        if (locindx == 1) locationOne();
                        if (locindx == 2) locationTwo();
                        if (locindx == 3) locationThree();
                        if (locindx == 4) locationFour();
                        if (locindx == 5) locationFive();
                        if (locindx == 6) locationSix();
                        if (locindx == 7) locationSeven();
                        locindx++;
                        if (locindx >= 8) {
                            clearInterval(locinterval);
                            var bounds = new mapboxgl.LngLatBounds();
                            bounds.extend(locOnePointLatLng);
                            bounds.extend(locTwoPointLatLng);
                            bounds.extend(locThreePointLatLng);
                            bounds.extend(locFourPointLatLng);
                            bounds.extend(locFivePointLatLng);
                            bounds.extend(locSixPointLatLng);
                            bounds.extend(locSevenPointLatLng);
                            map.fitBounds(bounds, {
                                padding: 30
                            });
                        }
                    }, 400);
                }, 0);
            }
            placeMarkers();
        }
        var createGeoJSONCircle = function(center, radiusInKm, points) {
            if (!points) points = 64;
            var coords = {
                latitude: center[1],
                longitude: center[0]
            };
            var km = radiusInKm;
            var ret = [];
            var distanceX = km / (111.32 * Math.cos(coords.latitude * Math.PI / 180));
            var distanceY = km / 110.574;
            var theta, x, y;
            for(var i = 0; i < points; i++){
                theta = i / points * (2 * Math.PI);
                x = distanceX * Math.cos(theta);
                y = distanceY * Math.sin(theta);
                ret.push([
                    coords.longitude + x,
                    coords.latitude + y
                ]);
            }
            ret.push(ret[0]);
            return {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [
                        {
                            type: "Feature",
                            geometry: {
                                type: "Polygon",
                                coordinates: [
                                    ret
                                ]
                            }
                        }
                    ]
                }
            };
        };
        // home locations carousel
        document.getElementById("locone").addEventListener("click", (e)=>{
            // feature for Dana Point
            map.setPaintProperty("polygon1", "fill-opacity", 0.35);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon1";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("loctwo").addEventListener("click", (e)=>{
            // feature for Riverside
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0.35);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon2";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("locthree").addEventListener("click", (e)=>{
            // feature for Huntington Beach
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0.35);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon3";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("locfour").addEventListener("click", (e)=>{
            // feature for Beverly Hills
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0.35);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon4";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("locfive").addEventListener("click", (e)=>{
            // feature for Beverly Hills
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0.35);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon5";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("locsix").addEventListener("click", (e)=>{
            // feature for Palmdale
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0.35);
            map.setPaintProperty("polygon7", "fill-opacity", 0);
            curLoc = "polygon6";
            homelocationinnerwrap[0].classList.add("active");
        });
        document.getElementById("locseven").addEventListener("click", (e)=>{
            // feature for Valencia
            map.setPaintProperty("polygon1", "fill-opacity", 0);
            map.setPaintProperty("polygon2", "fill-opacity", 0);
            map.setPaintProperty("polygon3", "fill-opacity", 0);
            map.setPaintProperty("polygon4", "fill-opacity", 0);
            map.setPaintProperty("polygon5", "fill-opacity", 0);
            map.setPaintProperty("polygon6", "fill-opacity", 0);
            map.setPaintProperty("polygon7", "fill-opacity", 0.35);
            curLoc = "polygon7";
            homelocationinnerwrap[0].classList.add("active");
        });
        // home loca
        // var homelocationssplide = new Splide('.homelocationsplide', {
        //    direction: 'ttb',
        //    height: '100%',
        //   perPage: 5,
        //   perMove: 1,
        //    type: 'slide',
        //   drag: false,
        // classes: {
        //     arrows: 'splide__arrows homeloc-arrows',
        //     arrow : 'splide__arrow homeloc-arrow',
        //     prev  : 'splide__arrow--prev homeloc-prev',
        //     next  : 'splide__arrow--next homeloc-next',
        // },
        //  pagination: false,
        // });
        // homelocationssplide.on( 'mounted', function () {
        let homelocationsheight = jQuery(".homelocations").outerHeight();
        let box = document.querySelector(".homelocationsplide");
        let locrect = box.getBoundingClientRect();
        let locheight = 940;
        jQuery(".homemap").css({
            "height": locheight
        });
        loadHomeMap(map);
        map.on("load", function() {
            map.resize();
        });
    // } );
    // homelocationssplide.mount();
    }
    // mapbox two
    var homelocationstwo = document.querySelectorAll(".homelocationstwo");
    if (homelocationstwo.length > 0) {
        mapboxgl.accessToken = "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
        const map = new mapboxgl.Map({
            container: "maptwo",
            // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
            style: "mapbox://styles/mapbox/light-v11",
            center: [
                -117.906454,
                33.654739
            ],
            zoom: 8.8,
            interactive: false
        });
        map.scrollZoom.disable();
        map.on("load", ()=>{
        // map loaded
        });
        map.on("click", function(e) {
            const bbox = [
                [
                    e.point.x - 5,
                    e.point.y - 5
                ],
                [
                    e.point.x + 5,
                    e.point.y + 5
                ]
            ];
            // dana point
            const pointsOne = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points1"
                ]
            });
            if (pointsOne.length == 1) window.location.href = "/dana-point/";
            // Huntington Beach
            const pointsTwo = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points2"
                ]
            });
            if (pointsTwo.length == 1) window.location.href = "/locations-huntington-beach/";
            // Riverside
            const pointsThree = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points3"
                ]
            });
            if (pointsThree.length == 1) window.location.href = "/locations-riverside/";
            // Valley
            const pointsFour = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points4"
                ]
            });
            if (pointsFour.length == 1) window.location.href = "/san-fernando-valley/";
            // San Gabriel
            const pointsFive = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points5"
                ]
            });
            if (pointsFive.length == 1) window.location.href = "/locations-san-gabriel-valley/";
            // Antelope Valley
            const pointsSix = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points6"
                ]
            });
            if (pointsSix.length == 1) window.location.href = "/locations-antelope-valley/";
            // Valencia
            const pointsSeven = map.queryRenderedFeatures(bbox, {
                layers: [
                    "points7"
                ]
            });
            if (pointsSeven.length == 1) window.location.href = "/locations-valencia/";
        });
        loadMapTwo(map);
        function loadMapTwo(map) {
            // Dana Point
            const locOnePointLatLng = [
                -117.7231871,
                33.4943349
            ];
            function locationOne() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker1", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points1", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Dana Point
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locOnePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points1",
                        "interactive": true,
                        type: "symbol",
                        source: "points1",
                        layout: {
                            "icon-image": "custom-marker1",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon1", createGeoJSONCircle(locOnePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon1",
                    type: "fill",
                    source: "polygon1",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
            }
            // Huntington Beach
            const locTwoPointLatLng = [
                -117.80613095792333,
                33.70670350274985
            ];
            function locationTwo() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker2", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points2", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locTwoPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points2",
                        type: "symbol",
                        source: "points2",
                        layout: {
                            "icon-image": "custom-marker2",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon2", createGeoJSONCircle(locTwoPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon2",
                    type: "fill",
                    source: "polygon2",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0
                    }
                });
            }
            // Riverside
            const locThreePointLatLng = [
                -117.401028,
                33.9493029
            ];
            function locationThree() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker3", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points3", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locThreePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points3",
                        type: "symbol",
                        source: "points3",
                        layout: {
                            "icon-image": "custom-marker3",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon3", createGeoJSONCircle(locThreePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon3",
                    type: "fill",
                    source: "polygon3",
                    layout: {},
                    paint: {
                        "fill-color": "#a1d9d2",
                        "fill-opacity": 0
                    }
                });
            }
            // Valley
            const locFourPointLatLng = [
                -118.5294178,
                34.2007831
            ];
            function locationFour() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker4", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points4", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFourPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points4",
                        type: "symbol",
                        source: "points4",
                        layout: {
                            "icon-image": "custom-marker4",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon4", createGeoJSONCircle(locFourPointLatLng, 30.0));
                map.addLayer({
                    id: "polygon4",
                    type: "fill",
                    source: "polygon4",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
            }
            // San Gabriel
            const locFivePointLatLng = [
                -117.9261074,
                34.071511
            ];
            function locationFive() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker5", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points5", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFivePointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points5",
                        type: "symbol",
                        source: "points5",
                        layout: {
                            "icon-image": "custom-marker5",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon5", createGeoJSONCircle(locFivePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon5",
                    type: "fill",
                    source: "polygon5",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0
                    }
                });
            }
            // Antelope Valley
            const locSixPointLatLng = [
                -118.1426083,
                34.5872707
            ];
            function locationSix() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker6", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points6", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSixPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points6",
                        type: "symbol",
                        source: "points6",
                        layout: {
                            "icon-image": "custom-marker6",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon6", createGeoJSONCircle(locFivePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon6",
                    type: "fill",
                    source: "polygon6",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0
                    }
                });
            }
            // Valencia
            const locSevenPointLatLng = [
                -118.5808355,
                34.4068893
            ];
            function locationSeven() {
                map.loadImage($2ad374ddd6de712e$var$mapIcon, (error, image)=>{
                    if (error) throw error;
                    map.addImage("custom-marker7", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points7", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [
                                {
                                    // feature for Dana Point
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSevenPointLatLng
                                    }
                                }
                            ]
                        }
                    });
                    // Add a symbol layer
                    map.addLayer({
                        id: "points7",
                        "interactive": true,
                        type: "symbol",
                        source: "points7",
                        layout: {
                            "icon-image": "custom-marker1",
                            // get the title name from the source's "title" property
                            "text-field": [
                                "get",
                                "title"
                            ],
                            "text-font": [
                                "Open Sans Semibold",
                                "Arial Unicode MS Bold"
                            ],
                            "text-offset": [
                                0,
                                1.25
                            ],
                            "text-anchor": "top"
                        }
                    });
                });
                map.addSource("polygon7", createGeoJSONCircle(locOnePointLatLng, 30.0));
                map.addLayer({
                    id: "polygon7",
                    type: "fill",
                    source: "polygon7",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0
                    }
                });
            }
            function placeMarkers() {
                let locinterval;
                let locindx = 1;
                setTimeout(()=>{
                    // call your func here
                    locinterval = setInterval(()=>{
                        if (locindx == 1) locationOne();
                        if (locindx == 2) locationTwo();
                        if (locindx == 3) locationThree();
                        if (locindx == 4) locationFour();
                        if (locindx == 5) locationFive();
                        if (locindx == 6) locationSix();
                        if (locindx == 7) locationSeven();
                        locindx++;
                        if (locindx >= 8) {
                            clearInterval(locinterval);
                            var bounds = new mapboxgl.LngLatBounds();
                            bounds.extend(locOnePointLatLng);
                            bounds.extend(locTwoPointLatLng);
                            bounds.extend(locThreePointLatLng);
                            bounds.extend(locFourPointLatLng);
                            bounds.extend(locFivePointLatLng);
                            bounds.extend(locSixPointLatLng);
                            bounds.extend(locSevenPointLatLng);
                            map.fitBounds(bounds, {
                                padding: 100
                            });
                        }
                    }, 400);
                }, 0);
            }
            placeMarkers();
        }
        var createGeoJSONCircle = function(center, radiusInKm, points) {
            if (!points) points = 64;
            var coords = {
                latitude: center[1],
                longitude: center[0]
            };
            var km = radiusInKm;
            var ret = [];
            var distanceX = km / (111.32 * Math.cos(coords.latitude * Math.PI / 180));
            var distanceY = km / 110.574;
            var theta, x, y;
            for(var i = 0; i < points; i++){
                theta = i / points * (2 * Math.PI);
                x = distanceX * Math.cos(theta);
                y = distanceY * Math.sin(theta);
                ret.push([
                    coords.longitude + x,
                    coords.latitude + y
                ]);
            }
            ret.push(ret[0]);
            return {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [
                        {
                            type: "Feature",
                            geometry: {
                                type: "Polygon",
                                coordinates: [
                                    ret
                                ]
                            }
                        }
                    ]
                }
            };
        };
    }
    // main carousel
    var homesplide = document.querySelectorAll(".homesplide");
    if (homesplide.length > 0) {
        var homevertsplide = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(".homesplide", {
            direction: "ttb",
            height: "550px",
            perPage: 5,
            perMove: 1,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: "280px"
                }
            },
            type: "loop",
            classes: {
                arrows: "splide__arrows homevert-arrows",
                arrow: "splide__arrow homevert-arrow",
                prev: "splide__arrow--prev homevert-prev",
                next: "splide__arrow--next homevert-next"
            },
            pagination: false
        });
        homevertsplide.mount();
        // desktop close menu button
        const vertlinks = document.querySelectorAll(".vertlink");
        vertlinks.forEach((el)=>el.addEventListener("click", (event)=>{
                let vertlinkid = event.target.parentElement.id;
                vertlinkid = vertlinkid.replace("vert", "");
                vertlinkid = Number(vertlinkid) - 1;
                homevertsplide.go(vertlinkid);
            }));
    }
    // comparison carousel
    var comparisonsplide = document.querySelectorAll(".comparisonsplide");
    if (comparisonsplide.length > 0) {
        var comparisonvertsplide = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(".comparisonsplide", {
            direction: "ttb",
            height: "430px",
            perPage: 3,
            perMove: 1,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: "280px"
                }
            },
            type: "loop",
            classes: {
                arrows: "splide__arrows homevert-arrows",
                arrow: "splide__arrow homevert-arrow",
                prev: "splide__arrow--prev homevert-prev",
                next: "splide__arrow--next homevert-next"
            },
            pagination: false
        });
        comparisonvertsplide.mount();
        // desktop close menu button
        const vertlinks = document.querySelectorAll(".vertlink");
        vertlinks.forEach((el)=>el.addEventListener("click", (event)=>{
                let vertlinkid = event.target.parentElement.id;
                vertlinkid = vertlinkid.replace("vert", "");
                vertlinkid = Number(vertlinkid) - 1;
                comparisonvertsplide.go(vertlinkid);
            }));
    }
    var medicalhealthwrap = document.querySelectorAll(".medicalhealthimg");
    const classnames = [
        "medone",
        "medtwo",
        "medthree",
        "medfour",
        "medfive",
        "medsix"
    ];
    if (medicalhealthwrap.length > 0) {
        const initialDelay = 0.3;
        const delay = 1;
        let interval;
        let indx = 0;
        let medicalinit = true;
        window.onscroll = function(e) {
            // called when the window is scrolled.  
            let testMedicalPos = isScrolledIntoView(medicalhealthwrap);
            if (testMedicalPos == true && medicalinit == true) {
                medicalinit = false;
                setTimeout(()=>{
                    // call your func here
                    interval = setInterval(()=>{
                        let calloutel = document.getElementsByClassName(classnames[indx])[0];
                        calloutel.classList.add("active");
                        indx++;
                        if (indx >= 6) {
                            clearInterval(interval);
                            closeMedCallouts();
                        }
                    }, delay * 500);
                }, 100);
            }
        };
    }
    function closeMedCallouts() {
        const closedelay = 1;
        let closeinterval;
        let closeindx = 0;
        setTimeout(()=>{
            closeinterval = setInterval(()=>{
                let calloutel = document.getElementsByClassName(classnames[closeindx])[0];
                calloutel.classList.remove("active");
                closeindx++;
                if (closeindx >= 6) clearInterval(closeinterval);
            }, closedelay * 300);
        }, 3000);
    }
    var medcallouts = document.querySelectorAll(".medcirc");
    medcallouts.forEach((el)=>el.addEventListener("click", (event)=>{
            event.currentTarget.classList.toggle("active");
        }));
    // blog list
    let currentPage = 1;
    window.currentCat = "";
    const domain = window.location.hostname;
    function showMore() {
        document.getElementById("showmore").addEventListener("click", (e)=>{
            e.preventDefault();
            currentPage++;
            // Creating data 
            let requestDataFirst = {
                action: "weichie_load_more",
                locales: "localestester",
                terms: "termstest",
                paged: currentPage,
                cat: window.currentCat,
                nonce: "test nonce"
            };
            // Initiating AJAX request for start of places list - limit 6
            fetch("https://" + domain + "/wp-admin/admin-ajax.php", {
                method: "post",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(requestDataFirst).toString()
            }).then(function(response) {
                return response.text();
            }).then(function(response) {
                if (response == 0) document.querySelector(".bloglistmoreinner").innerHTML = "";
                else {
                    document.querySelector(".bloglistinner .blogitem:last-child").insertAdjacentHTML("afterend", response);
                    showBlogMore();
                }
            });
        });
    }
    const bloglistouter = document.querySelector(".bloglistouter");
    if (bloglistouter) showMore();
    const partnerform = document.getElementById("partnerform");
    if (partnerform) {
        var partnerlinks = document.querySelectorAll(".partnerclick");
        partnerlinks.forEach((el)=>el.addEventListener("click", (event)=>{
                event.preventDefault();
                jQuery("html, body").animate({
                    scrollTop: jQuery("#partnerform").offset().top
                }, "slow");
            }));
    }
    // catlinks
    const catlinks = document.querySelectorAll(".catlink");
    catlinks.forEach((el)=>el.addEventListener("click", (event)=>{
            event.preventDefault();
            let catlink = event.target.getAttribute("href");
            catlink = catlink.replace("#", "");
            let blogcount = event.target.getAttribute("data-catcount");
            window.currentCat = catlink;
            // Creating data 
            let requestCatDataFirst = {
                action: "weichie_load_more",
                cat: window.currentCat,
                paged: 1,
                nonce: "test nonce"
            };
            // Initiating AJAX request for start of places list - limit 6
            fetch("https://" + domain + "/wp-admin/admin-ajax.php", {
                method: "post",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(requestCatDataFirst).toString()
            }).then(function(response) {
                return response.text();
            }).then(function(response) {
                document.querySelector(".bloglistinner").innerHTML = response;
                showBlogMore();
                currentPage = 1;
            });
        }));
    // blog more
    function showBlogMore() {
        let windowcatid = window.currentCat;
        if (windowcatid == "") windowcatid = "0";
        let blogcount = document.getElementById("cat" + windowcatid).getAttribute("data-catcount");
        let curitems = document.querySelectorAll(".blogitem").length;
        // console.log(blogcount);
        // console.log(curitems);
        if (blogcount > 3 && curitems < blogcount) {
            document.querySelector(".bloglistmoreinner").innerHTML = '<button id="showmore" class="sitebutton fatwide green">Show More</button>';
            showMore();
        } else document.querySelector(".bloglistmoreinner").innerHTML = "";
    }
    // Event Popup
    const eventpopup = document.getElementById("eventpopup");
    if (eventpopup) {
        let eventpopup = (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("eventpopup");
        if (eventpopup == undefined) {
            (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).set("eventpopup", 1);
            (0, $8e05255c34978941$export$cb45b08d97cdc4fd).show([
                {
                    src: "#eventpopup",
                    type: "inline"
                }
            ]);
        }
        const pillarsbtn = document.getElementById("pillarsbtn");
        pillarsbtn.addEventListener("click", (e)=>{
            jQuery("html, body").animate({
                scrollTop: jQuery("#pillars").offset().top - 200
            }, "slow");
            (0, $8e05255c34978941$export$cb45b08d97cdc4fd).close();
            e.preventDefault();
        });
    }
    const isElementXPercentInViewport = function(funcel, percentVisible = 0.5) {
        const el = funcel[0];
        let rect = el.getBoundingClientRect(), windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return !(Math.floor(100 - (rect.top >= 0 ? 0 : rect.top) / +-rect.height * 100) < percentVisible || Math.floor(100 - (rect.bottom - windowHeight) / rect.height * 100) < percentVisible);
    };
    // check if element is in view
    function isScrolledIntoView(elem) {
        // const el = element[0];
        // const r = el.getBoundingClientRect();
        // const vw = document.documentElement.clientWidth;
        // const vh = document.documentElement.clientHeight;
        // const inViewX = (r.left > 0 && r.left < vw) || (r.right < vw && r.right > 0);
        // const inViewY = (r.top > 0 && r.top < vh) || (r.bottom < vh && r.bottom > 0);
        // return inViewX && inViewY;
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height() + 500;
        var elemTop = jQuery(elem).offset().top;
        var elemBottom = elemTop + jQuery(elem).height();
        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    function isScrolledMobIntoView(elem) {
        var docHeight = jQuery(document).height();
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height() + 1000;
        var elemTop = jQuery(elem).offset().top;
        var elemBottom = elemTop + jQuery(elem).height();
        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    // video links
    var videolinks = document.querySelectorAll(".videolink");
    videolinks.forEach(setVideoLink);
    function setVideoLink(el) {
        let videolinkel = el;
        videolinkel.addEventListener("click", (e)=>{
            let videolink = videolinkel.getAttribute("href");
            (0, $8e05255c34978941$export$cb45b08d97cdc4fd).show([
                {
                    src: videolink,
                    type: "video",
                    ratio: 1.6,
                    width: 900,
                    height: 506,
                    youtube: {
                        autoplay: 0
                    },
                    vimeo: {
                        autoplay: 0
                    }
                }
            ]);
            e.preventDefault();
        });
    }
});
const $2ad374ddd6de712e$var$locationmap = document.getElementById("locationmap");
if ($2ad374ddd6de712e$var$locationmap) window.initMap = async function() {
    const locationsarray = [
        {
            lat: 34.0714701,
            lng: -117.9235736
        },
        {
            lat: 33.494338,
            lng: -117.72064
        },
        {
            lat: 33.701466,
            lng: -117.990421
        },
        {
            lat: 33.949302,
            lng: -117.39845
        },
        {
            lat: 34.200814,
            lng: -118.526751
        },
        {
            lat: 34.5872707,
            lng: -118.1426083
        },
        {
            lat: 34.4067611,
            lng: -118.5784806
        },
        {
            lat: 35.3546407,
            lng: -119.1020583
        },
        {
            lat: 33.70668565234832,
            lng: -117.80616314576659
        } // Tustin
    ];
    let myLatLng;
    if ($2ad374ddd6de712e$var$locationmap.classList.contains("sangabriel")) myLatLng = locationsarray[0];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("danapoint")) myLatLng = locationsarray[1];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("huntingtonbeach")) myLatLng = locationsarray[2];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("riverside")) myLatLng = locationsarray[3];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("reseda")) myLatLng = locationsarray[4];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("antelopevalley")) myLatLng = locationsarray[5];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("valencia")) myLatLng = locationsarray[6];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("bakersfield")) myLatLng = locationsarray[7];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("bakersfield")) myLatLng = locationsarray[7];
    else if ($2ad374ddd6de712e$var$locationmap.classList.contains("tustin")) myLatLng = locationsarray[8];
    const styles = {
        default: [],
        hide: [
            {
                featureType: "poi.medical",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.medical",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.business",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.business",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            }
        ]
    };
    const locmap = new google.maps.Map(document.getElementById("locationmap"), {
        zoom: 17,
        styles: styles["hide"],
        center: myLatLng
    });
    const image = "https://dentalimplantsgps.com/wp-content/themes/bridge-child/resources/images/gps_map_icon_2.png";
    const beachMarker = new google.maps.Marker({
        position: myLatLng,
        map: locmap,
        icon: image
    });
};



})();
//# sourceMappingURL=parcel.js.map
